import React from 'react';

interface CreateTeamOnBoardingSVGProps {
	width: number;
	height: number;
}

const CreateTeamOnBoardingSVG = ({ width, height }: CreateTeamOnBoardingSVGProps) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 237 271"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1331_7994)">
			<mask
				id="mask0_1331_7994"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- SVG mask-type requires style attribute
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="237"
				height="271"
			>
				<path d="M236.312 0H0.444336V271H236.312V0Z" fill="white" />
			</mask>
			<g mask="url(#mask0_1331_7994)">
				<path
					d="M103.608 236.443L103.347 172.505L104.468 172.5L104.734 236.438L103.608 236.443Z"
					fill="url(#paint0_linear_1331_7994)"
				/>
				<path
					opacity="0.1"
					d="M187.193 131.307C192.741 128.611 201.272 128.064 206.443 133.255C209.319 136.141 210.102 139.751 210.358 141.631C212.408 141.07 215.535 140.577 218.285 142.061C221.484 143.792 221.707 146.87 225.07 150.273C226.617 151.834 229.179 153.82 233.451 155.13C210.407 155.13 187.357 155.13 164.313 155.13C163.491 151.273 164.782 147.271 167.696 144.695C171.882 140.998 177.135 142.24 177.575 142.356C178.194 140.669 180.663 134.483 187.193 131.307Z"
					fill="url(#paint1_linear_1331_7994)"
				/>
				<path
					opacity="0.1"
					d="M209.967 158.137C213.128 156.6 217.985 156.29 220.928 159.248C222.567 160.891 223.011 162.946 223.156 164.018C224.321 163.699 226.105 163.419 227.67 164.265C229.493 165.251 229.618 167.005 231.537 168.943C232.417 169.833 233.876 170.964 236.312 171.708C223.185 171.708 210.063 171.708 196.936 171.708C196.468 169.509 197.202 167.233 198.865 165.763C201.248 163.656 204.239 164.366 204.491 164.429C204.839 163.468 206.245 159.949 209.967 158.137Z"
					fill="url(#paint2_linear_1331_7994)"
				/>
				<path
					opacity="0.1"
					d="M26.7899 133.009C23.629 131.472 18.7717 131.162 15.8283 134.12C14.1898 135.763 13.7452 137.818 13.6002 138.891C12.4354 138.572 10.652 138.291 9.08602 139.137C7.26392 140.123 7.13826 141.877 5.2195 143.816C4.33986 144.705 2.88025 145.836 0.444336 146.58C13.5712 146.58 26.6932 146.58 39.8201 146.58C40.2889 144.381 39.5542 142.105 37.8916 140.635C35.5089 138.528 32.5172 139.239 32.2658 139.301C31.9179 138.34 30.5114 134.816 26.7899 133.009Z"
					fill="url(#paint3_linear_1331_7994)"
				/>
				<path
					opacity="0.1"
					d="M54.5275 174.134C61.4679 170.76 72.1347 170.074 78.6015 176.57C82.1973 180.18 83.1785 184.694 83.4975 187.043C86.059 186.342 89.9691 185.724 93.4103 187.584C97.4121 189.75 97.6876 193.602 101.897 197.855C103.831 199.807 107.035 202.292 112.38 203.93C83.5603 203.93 54.7402 203.93 25.9201 203.93C24.8906 199.107 26.5049 194.104 30.1539 190.88C35.3882 186.255 41.9565 187.811 42.5123 187.952C43.2711 185.84 46.3595 178.106 54.5275 174.134Z"
					fill="url(#paint4_linear_1331_7994)"
				/>
				<path
					opacity="0.1"
					d="M60.4284 47.8817C53.2753 44.4066 42.2799 43.701 35.615 50.3901C31.908 54.1116 30.8978 58.7611 30.5692 61.1825C27.9254 60.4576 23.8994 59.8244 20.3519 61.7383C16.2244 63.9713 15.944 67.9393 11.6039 72.323C9.6126 74.3384 6.30672 76.8951 0.801758 78.5819C30.5063 78.5819 60.2109 78.5819 89.9155 78.5819C90.9788 73.6086 89.3114 68.4516 85.556 65.1312C80.1622 60.3657 73.3909 61.9703 72.8206 62.1153C72.0328 59.9452 68.8478 51.9705 60.4284 47.8817Z"
					fill="url(#paint5_linear_1331_7994)"
				/>
				<path
					d="M105.073 236.487L103.956 236.347L111.114 178.924L112.23 179.059L105.073 236.487Z"
					fill="url(#paint6_linear_1331_7994)"
				/>
				<path
					d="M85.885 80.0035C84.7009 90.6702 92.3856 100.279 103.052 101.463L107.62 101.97C110.602 102.304 113.202 104.135 114.521 106.827L115.638 109.109L117.228 107.127C119.103 104.788 122.047 103.575 125.029 103.903C135.696 105.088 145.304 97.4028 146.488 86.7361C147.672 76.0693 139.987 66.461 129.321 65.2768L107.344 62.8361C96.6775 61.6471 87.0692 69.3367 85.885 80.0035Z"
					fill="url(#paint7_radial_1331_7994)"
				/>
				<path
					d="M85.8852 80.0031C85.8369 80.4236 85.8079 80.8441 85.7886 81.2646C86.9437 81.3709 88.1278 81.5691 89.3313 81.8929C98.1325 84.2708 101.09 91.3901 107.335 96.0927C108.775 97.1753 110.505 98.2193 112.613 99.0989C115.856 92.6273 122.782 88.4322 130.442 89.0411L145.758 90.2591C145.894 89.8193 146.015 89.3698 146.116 88.9106C141.752 86.4264 135.507 83.8117 128.001 83.8745C119.128 83.9518 116.73 87.7072 110.66 86.0494C102.067 83.7102 101.989 74.1888 92.874 71.5789C91.6802 71.2358 90.5009 71.0231 89.3506 70.8975C87.4995 73.5025 86.2622 76.6006 85.8852 80.0031Z"
					fill="url(#paint8_linear_1331_7994)"
				/>
				<path
					d="M101.627 101.245C99.7127 100.568 97.8036 99.8866 95.8896 99.21C97.6441 100.162 99.5677 100.858 101.627 101.245Z"
					fill="url(#paint9_linear_1331_7994)"
				/>
				<path
					d="M107.339 96.0928C101.095 91.3901 98.137 84.2709 89.3358 81.893C88.1324 81.5691 86.9483 81.371 85.7931 81.2646C85.4403 88.8479 89.5292 95.7303 95.8896 99.2053C97.8035 99.882 99.7126 100.563 101.627 101.24C102.095 101.327 102.569 101.404 103.052 101.458L107.62 101.965C108.891 102.105 110.089 102.521 111.153 103.159C111.481 101.728 111.979 100.37 112.617 99.0942C110.505 98.2194 108.775 97.1754 107.339 96.0928Z"
					fill="url(#paint10_linear_1331_7994)"
				/>
				<path
					d="M107.339 96.0928C101.095 91.3901 98.137 84.2709 89.3358 81.893C88.1324 81.5691 86.9483 81.371 85.7931 81.2646C85.4403 88.8479 89.5292 95.7303 95.8896 99.2053C97.8035 99.882 99.7126 100.563 101.627 101.24C102.095 101.327 102.569 101.404 103.052 101.458L107.62 101.965C108.891 102.105 110.089 102.521 111.153 103.159C111.481 101.728 111.979 100.37 112.617 99.0942C110.505 98.2194 108.775 97.1754 107.339 96.0928Z"
					fill="url(#paint11_linear_1331_7994)"
				/>
				<path
					d="M112.612 99.0949C118.214 101.424 126.474 102.551 138.934 100.047C142.114 97.6256 144.545 94.2327 145.758 90.2502L130.442 89.0322C122.781 88.4281 115.855 92.6281 112.612 99.0949Z"
					fill="url(#paint12_linear_1331_7994)"
				/>
				<path
					opacity="0.3"
					d="M112.612 99.0949C118.214 101.424 126.474 102.551 138.934 100.047C142.114 97.6256 144.545 94.2327 145.758 90.2502L130.442 89.0322C122.781 88.4281 115.855 92.6281 112.612 99.0949Z"
					fill="#57D9A3"
				/>
				<path
					d="M114.517 106.828L115.633 109.109L117.223 107.127C117.296 107.036 117.373 106.953 117.45 106.866C116.218 106.427 114.981 105.992 113.748 105.552C114.038 105.948 114.299 106.373 114.517 106.828Z"
					fill="url(#paint13_linear_1331_7994)"
				/>
				<path
					d="M114.517 106.828L115.633 109.109L117.223 107.127C117.296 107.036 117.373 106.953 117.45 106.866C116.218 106.427 114.981 105.992 113.748 105.552C114.038 105.948 114.299 106.373 114.517 106.828Z"
					fill="#DFE1E5"
				/>
				<path
					d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z"
					fill="url(#paint14_linear_1331_7994)"
				/>
				<path
					d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z"
					fill="url(#paint15_linear_1331_7994)"
				/>
				<path
					opacity="0.3"
					d="M112.612 99.0947C111.974 100.371 111.477 101.729 111.148 103.159C112.163 103.768 113.047 104.576 113.748 105.547C114.981 105.987 116.218 106.422 117.45 106.862C119.33 104.696 122.158 103.585 125.024 103.904C130.191 104.479 135.101 102.966 138.934 100.052C126.474 102.555 118.214 101.424 112.612 99.0947Z"
					fill="#57D9A3"
				/>
				<g opacity="0.8">
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M102.452 74.6045L102.273 75.9459L133.149 80.0577L133.328 78.7163L102.452 74.6045Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M101.856 79.1006L101.677 80.442L132.553 84.5537L132.731 83.2124L101.856 79.1006Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M101.253 83.5947L101.074 84.9361L131.95 89.0479L132.128 87.7065L101.253 83.5947Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M100.656 88.0889L100.478 89.4303L120.68 92.1206L120.858 90.7792L100.656 88.0889Z"
							fill="#E3FCEF"
						/>
					</g>
				</g>
				<path
					d="M43.4788 173.859C45.7987 182.969 55.0638 188.474 64.1743 186.154L68.0747 185.163C70.6218 184.516 73.3187 185.217 75.2326 187.014L76.8517 188.542L77.5429 186.425C78.3597 183.926 80.3992 182.022 82.9415 181.374C92.052 179.054 97.557 169.789 95.237 160.679C92.9171 151.568 83.652 146.063 74.5415 148.383L55.7695 153.163C46.6638 155.478 41.1588 164.743 43.4788 173.859Z"
					fill="url(#paint16_radial_1331_7994)"
				/>
				<path
					d="M66.0304 180.432C71.5692 182.061 80.1625 182.041 93.1589 173.926C95.2275 170.63 96.17 166.638 95.6093 162.578C91.2643 161.892 85.3389 161.669 79.2056 164.043C71.951 166.846 71.1487 170.659 65.6582 171.181C57.8865 171.916 54.89 164.134 46.6108 164.806C45.5281 164.893 44.4938 165.082 43.5127 165.333C42.7974 168.04 42.7394 170.959 43.4789 173.868C43.5707 174.231 43.677 174.584 43.793 174.932C44.7742 174.661 45.8085 174.458 46.8911 174.352C54.8416 173.578 59.4621 178.499 66.0304 180.432Z"
					fill="url(#paint17_linear_1331_7994)"
				/>
				<path
					d="M75.2326 187.014L76.8517 188.542L77.5428 186.425C77.5767 186.328 77.6105 186.236 77.6443 186.14C76.4989 186.159 75.3486 186.183 74.2031 186.202C74.5656 186.444 74.9136 186.71 75.2326 187.014Z"
					fill="url(#paint18_linear_1331_7994)"
				/>
				<path
					d="M62.9369 186.415C61.1583 186.449 59.3797 186.483 57.606 186.517C59.3411 186.758 61.1342 186.734 62.9369 186.415Z"
					fill="url(#paint19_linear_1331_7994)"
				/>
				<path
					d="M57.6061 186.516C59.3847 186.482 61.1633 186.448 62.9371 186.415C63.3479 186.342 63.7636 186.26 64.1744 186.154L68.0747 185.163C70.1917 184.622 72.4198 185.018 74.208 186.207C75.3535 186.187 76.5038 186.163 77.6492 186.144C78.524 183.79 80.5008 182.002 82.9464 181.379C87.359 180.257 90.9211 177.502 93.1637 173.926C80.1673 182.045 71.574 182.06 66.0352 180.431C59.4621 178.503 54.8416 173.578 46.891 174.346C45.8036 174.453 44.7741 174.656 43.793 174.926C45.8374 181.248 51.3182 185.627 57.6061 186.516Z"
					fill="url(#paint20_linear_1331_7994)"
				/>
				<path
					d="M57.6061 186.516C59.3847 186.482 61.1633 186.448 62.9371 186.415C63.3479 186.342 63.7636 186.26 64.1744 186.154L68.0747 185.163C70.1917 184.622 72.4198 185.018 74.208 186.207C75.3535 186.187 76.5038 186.163 77.6492 186.144C78.524 183.79 80.5008 182.002 82.9464 181.379C87.359 180.257 90.9211 177.502 93.1637 173.926C80.1673 182.045 71.574 182.06 66.0352 180.431C59.4621 178.503 54.8416 173.578 46.891 174.346C45.8036 174.453 44.7741 174.656 43.793 174.926C45.8374 181.248 51.3182 185.627 57.6061 186.516Z"
					fill="url(#paint21_linear_1331_7994)"
				/>
				<path
					d="M81.9726 158.076L55.3887 164.237L55.6942 165.556L82.2782 159.394L81.9726 158.076Z"
					fill="#E3FCEF"
				/>
				<path
					d="M82.8594 161.945L56.2754 168.102L56.5807 169.42L83.1647 163.264L82.8594 161.945Z"
					fill="#E3FCEF"
				/>
				<path
					d="M83.7612 165.815L57.1772 171.977L57.4828 173.295L84.0668 167.133L83.7612 165.815Z"
					fill="#E3FCEF"
				/>
				<path
					d="M75.4735 171.812L58.0757 175.845L58.3813 177.163L75.779 173.131L75.4735 171.812Z"
					fill="#E3FCEF"
				/>
				<path
					d="M187.289 120.539C199.301 120.539 209.038 110.802 209.038 98.7902C209.038 86.7785 199.301 77.041 187.289 77.041C175.277 77.041 165.54 86.7785 165.54 98.7902C165.54 110.802 175.277 120.539 187.289 120.539Z"
					fill="url(#paint22_linear_1331_7994)"
				/>
				<path
					d="M166.028 94.208C164.085 103.164 168.015 112.27 175.535 117.093C176.086 115.575 176.448 113.966 176.584 112.279C177.207 104.425 172.78 97.3351 166.028 94.208Z"
					fill="#FFAB00"
				/>
				<path
					d="M178.333 94.885C179.612 94.885 180.648 93.8485 180.648 92.57C180.648 91.2914 179.612 90.2549 178.333 90.2549C177.055 90.2549 176.018 91.2914 176.018 92.57C176.018 93.8485 177.055 94.885 178.333 94.885Z"
					fill="#FF991F"
				/>
				<path
					d="M198.333 100.859C199.612 100.859 200.648 99.8222 200.648 98.5436C200.648 97.265 199.612 96.2285 198.333 96.2285C197.055 96.2285 196.018 97.265 196.018 98.5436C196.018 99.8222 197.055 100.859 198.333 100.859Z"
					fill="#FF991F"
				/>
				<path
					d="M175.825 100.327C177.483 103.759 180.465 106.538 184.375 107.804C188.285 109.07 192.33 108.553 195.685 106.746L175.825 100.327Z"
					fill="#FF991F"
				/>
				<path
					d="M127.595 14.1849C127.609 14.1269 127.788 14.1704 128.296 14.0399C128.576 13.9674 128.735 13.9239 128.851 13.8369C129.262 13.5228 129.083 12.6721 129.049 12.5078C129.852 12.5078 130.659 12.5078 131.461 12.5078C131.447 12.7301 131.432 13.0105 131.418 13.3343C131.403 13.7354 131.403 13.8224 131.461 13.9143C131.669 14.2767 132.268 14.1608 132.302 14.3154C132.341 14.4991 131.539 15.0017 130.562 15.1081C128.962 15.2869 127.542 14.3637 127.595 14.1849Z"
					fill="#9C7761"
				/>
				<path
					d="M127.46 17.3116C126.952 17.7659 125.314 16.6785 124.652 16.2435C123.525 15.4943 121.824 13.2566 120.36 11.0527C120.176 10.7772 120.06 10.4679 120.012 10.144C119.828 8.94542 119.388 6.06002 119.113 4.46508C119.862 3.99626 120.137 4.39742 120.713 4.35392C121.191 6.36934 121.602 8.08028 122.08 10.0957C122.283 10.3084 122.607 10.6564 123.028 11.0623C125.125 13.0971 126.053 13.3533 126.865 14.7114C127.382 15.562 127.89 16.925 127.46 17.3116Z"
					fill="#B08874"
				/>
				<path
					d="M128.59 9.6953C128.387 9.55997 128.063 9.37147 127.851 8.97515C127.551 8.42417 127.498 7.54937 127.962 7.21105C128.184 7.04673 128.469 7.06606 128.677 7.08056C129.127 7.10956 129.446 7.32221 129.586 7.42854C129.745 7.38988 129.973 7.34155 130.248 7.32221C130.722 7.28838 131.534 7.21105 132.21 7.69437C133.046 8.28885 133.191 9.22165 133.23 9.43914C133.433 10.7151 132.66 11.6479 132.515 11.8219C132.148 12.2665 131.843 12.629 131.418 12.6387C130.456 12.6629 130.374 10.8794 128.59 9.6953Z"
					fill="#172B4D"
				/>
				<path
					d="M132.119 10.5895C132.268 10.6427 132.215 11.3387 132.022 11.822C131.645 12.7693 130.625 13.1849 130.166 13.3396C129.731 13.2864 129.296 13.2333 128.866 13.1849C128.523 12.5373 128.049 11.4208 128.068 9.99988C128.073 9.53107 128.131 9.11058 128.209 8.75293C128.465 8.92209 128.871 9.15408 129.407 9.29908C130.442 9.58423 131.157 9.33774 131.389 9.73406C131.597 10.0869 131.22 10.6185 131.5 10.8554C131.582 10.9279 131.688 10.9375 131.751 10.9423C131.882 10.749 132.032 10.5605 132.119 10.5895Z"
					fill="#B08874"
				/>
				<path
					d="M128.344 11.3435C128.745 11.3435 129.069 11.0189 129.069 10.6185C129.069 10.2181 128.745 9.89355 128.344 9.89355C127.944 9.89355 127.619 10.2181 127.619 10.6185C127.619 11.0189 127.944 11.3435 128.344 11.3435Z"
					fill="#172B4D"
				/>
				<path
					d="M130.137 11.3961C130.567 11.3961 130.915 11.0477 130.915 10.618C130.915 10.1882 130.567 9.83984 130.137 9.83984C129.707 9.83984 129.359 10.1882 129.359 10.618C129.359 11.0477 129.707 11.3961 130.137 11.3961Z"
					fill="#172B4D"
				/>
				<path
					d="M128.803 10.6182H129.712"
					stroke="#172B4D"
					strokeWidth="0.7343"
					strokeMiterlimit="10"
				/>
				<path
					d="M130.562 10.6182H131.471"
					stroke="#172B4D"
					strokeWidth="0.7343"
					strokeMiterlimit="10"
				/>
				<path
					d="M125.038 12.7451C124.709 13.0496 124.381 13.3493 124.047 13.6538C123.535 14.1226 123.028 14.5817 122.52 15.036C122.636 15.355 122.863 15.8625 123.317 16.3603C123.694 16.7711 124.062 16.9935 124.328 17.153C125.038 17.5734 125.454 17.8248 125.942 17.7523C126.667 17.6459 126.778 16.9596 127.547 16.9113C128.03 16.8823 128.18 17.1433 128.378 17.0176C128.919 16.6745 128.581 14.3449 127.45 13.8567C127.228 13.7601 126.909 13.8181 126.329 13.6103C126.014 13.4991 125.826 13.3928 125.758 13.3493C125.415 13.1414 125.183 12.9094 125.038 12.7451Z"
					fill="#79E2F2"
				/>
				<path
					d="M126.865 13.7455C126.391 13.8131 126.121 14.6058 126.014 14.9634C125.628 16.2249 125.599 17.3413 125.589 18.1823C125.565 19.9416 125.618 20.5602 125.57 22.4403C125.56 22.8705 125.555 23.088 125.541 23.3586C125.488 24.5137 125.338 25.9975 124.951 27.7471C126.072 28.3174 128.054 29.1246 130.611 29.1439C131.66 29.1536 132.578 29.0279 133.332 28.8636C133.404 27.3798 133.511 25.8428 133.651 24.2576C133.704 23.6583 133.772 22.8995 133.873 22.0537C134.038 20.6714 134.323 18.7478 134.854 16.4182C134.753 16.1717 134.574 15.814 134.26 15.4564C134.202 15.3887 133.926 15.0842 133.448 14.7701C132.728 14.2964 132.027 14.1418 131.645 14.0789C131.017 14.8039 130.089 15.1036 129.306 14.8378C128.692 14.6299 128.363 14.1418 128.252 13.9533C128.102 13.934 127.87 13.905 127.585 13.8566C127.092 13.7745 127 13.7261 126.865 13.7455Z"
					fill="#79E2F2"
				/>
				<path
					d="M133.259 15.0887C134.129 14.8373 135.637 17.2201 136.362 18.9842C137.029 20.6033 137.208 22.1161 137.227 23.2712C137.232 23.7255 136.981 24.1363 136.575 24.3442C135.594 24.842 134.24 25.3785 132.578 25.6491C131.065 25.8956 129.76 25.8473 128.789 25.7361C128.76 25.3736 128.731 25.016 128.702 24.6535C129.963 24.4602 131.399 24.1508 132.936 23.6434C133.738 23.3824 134.482 23.0924 135.164 22.8024C134.84 21.9759 134.347 20.961 133.569 19.9267C133.216 19.4578 132.858 19.0519 132.515 18.7039C132.428 15.5382 133.027 15.1563 133.259 15.0887Z"
					fill="#B08874"
				/>
				<path
					d="M133.124 20.7144C133.443 20.4292 133.96 20.0378 134.685 19.7429C135.459 19.4288 136.15 19.3563 136.59 19.3418C136.155 18.1673 135.647 17.2877 135.256 16.6932C134.574 15.6492 134.115 15.2868 133.984 15.1853C133.525 14.8276 132.225 13.9721 131.679 14.3733C130.954 14.9049 131.863 17.4182 132.486 19.134C132.733 19.8154 132.965 20.3616 133.124 20.7144Z"
					fill="#79E2F2"
				/>
				<path
					d="M118.388 3.11218L119.113 4.4558L120.712 4.34464L120.964 2.96719C120.964 2.96719 121.186 1.56557 120.911 1.22242C120.862 1.15958 120.756 1.17408 120.674 1.23692C120.548 1.33358 120.49 1.80239 120.49 1.80239L120.287 2.28571C120.287 2.28571 120.181 0.579606 120.132 0.0914571C120.123 0.00446028 119.789 0.00446028 119.775 0.0914571C119.717 0.482943 119.664 1.86039 119.664 1.86039C119.664 1.86039 119.475 0.415279 119.34 0.0334592C119.311 -0.0535376 119.001 -0.000372879 118.982 0.0914571C118.91 0.482943 119.161 2.04889 119.161 2.04889C119.161 2.04889 118.885 0.84543 118.716 0.424945C118.687 0.347614 118.373 0.395946 118.383 0.482943C118.422 0.956592 118.649 2.32921 118.649 2.32921C118.649 2.32921 118.465 1.42541 118.325 0.971092C118.306 0.908261 118.088 1.03876 118.093 1.10642C118.132 1.58974 118.388 3.11218 118.388 3.11218Z"
					fill="#B08874"
				/>
				<path
					d="M86.5468 230.692L75.4209 187.962L76.5084 187.682L87.6343 230.407L86.5468 230.692Z"
					fill="url(#paint23_linear_1331_7994)"
				/>
				<path
					d="M86.5469 124.357L79.1812 75.6389L80.2928 75.4697L87.6585 124.188L86.5469 124.357Z"
					fill="url(#paint24_linear_1331_7994)"
				/>
				<path
					d="M142.457 234.123L141.543 233.466L165.255 200.484L166.168 201.142L142.457 234.123Z"
					fill="url(#paint25_linear_1331_7994)"
				/>
				<path
					d="M142.53 233.983L141.471 233.61L158.44 185.047L159.504 185.419L142.53 233.983Z"
					fill="url(#paint26_linear_1331_7994)"
				/>
				<path
					d="M141.969 234.133L140.853 234.017L146.087 182.524L147.203 182.636L141.969 234.133Z"
					fill="url(#paint27_linear_1331_7994)"
				/>
				<path
					d="M87.8421 230.435L84.4541 186.106L85.5754 186.019L88.9634 230.348L87.8421 230.435Z"
					fill="url(#paint28_linear_1331_7994)"
				/>
				<path
					d="M100.336 221.74C100.472 222.388 100.602 223.045 100.733 223.707C100.771 223.901 100.805 224.094 100.844 224.287C101.027 223.736 101.23 223.316 101.371 223.05C101.791 222.267 102.134 221.967 102.666 221.068C102.932 220.629 103.115 220.256 103.222 220.029C103.526 220.179 103.734 220.208 103.86 220.174C103.884 220.169 103.922 220.165 103.985 220.16C104.169 220.145 104.314 220.16 104.415 220.174C104.009 221.668 103.565 222.871 103.207 223.736C102.004 226.67 101.346 226.926 100.998 226.965C100.733 226.994 100.114 226.95 99.7224 226.54C99.5678 226.38 99.5146 226.206 99.4663 226.124C98.8379 225.022 98.664 223.983 98.606 223.35C99.1859 222.813 99.7611 222.277 100.336 221.74Z"
					fill="#E4B69D"
				/>
				<path
					d="M103.105 220.232C103.173 220.015 103.226 219.831 103.26 219.715C103.366 219.333 103.386 219.188 103.487 218.985C103.579 218.806 103.685 218.676 103.753 218.599L104.14 218.222H105.174L105.387 218.594V219.473V219.556C105.387 219.908 105.126 220.203 104.778 220.252L104.004 220.353C103.71 220.314 103.405 220.271 103.105 220.232Z"
					fill="#E4B69D"
				/>
				<path
					d="M125.782 177.223H124.656V236.419H125.782V177.223Z"
					fill="url(#paint29_linear_1331_7994)"
				/>
				<path
					d="M126.261 236.593L125.169 236.332L138.069 182.447L139.161 182.708L126.261 236.593Z"
					fill="url(#paint30_linear_1331_7994)"
				/>
				<path
					d="M88.0696 236.597C86.1992 236.597 84.6768 235.075 84.6768 233.204C84.6768 231.334 86.1992 229.812 88.0696 229.812C89.9401 229.812 91.4625 231.334 91.4625 233.204C91.4625 235.075 89.9401 236.597 88.0696 236.597ZM88.0696 230.933C86.8178 230.933 85.7981 231.953 85.7981 233.204C85.7981 234.456 86.8178 235.476 88.0696 235.476C89.3214 235.476 90.3412 234.456 90.3412 233.204C90.3412 231.953 89.3214 230.933 88.0696 230.933Z"
					fill="#EBECF0"
				/>
				<path
					d="M104.517 242.644C102.646 242.644 101.124 241.122 101.124 239.251C101.124 237.381 102.646 235.858 104.517 235.858C106.387 235.858 107.91 237.381 107.91 239.251C107.91 241.122 106.387 242.644 104.517 242.644ZM104.517 236.98C103.265 236.98 102.245 237.999 102.245 239.251C102.245 240.503 103.265 241.523 104.517 241.523C105.769 241.523 106.788 240.503 106.788 239.251C106.788 237.999 105.769 236.98 104.517 236.98Z"
					fill="#EBECF0"
				/>
				<path
					d="M125.222 242.644C123.352 242.644 121.829 241.122 121.829 239.251C121.829 237.381 123.352 235.858 125.222 235.858C127.092 235.858 128.615 237.381 128.615 239.251C128.615 241.122 127.092 242.644 125.222 242.644ZM125.222 236.98C123.97 236.98 122.95 237.999 122.95 239.251C122.95 240.503 123.97 241.523 125.222 241.523C126.474 241.523 127.494 240.503 127.494 239.251C127.494 237.999 126.474 236.98 125.222 236.98Z"
					fill="#EBECF0"
				/>
				<path
					d="M89.8868 221.764C89.4228 223.364 89.3407 224.635 89.3503 225.505C89.36 226.157 89.4228 226.563 89.4422 227.757C89.4615 228.961 89.418 229.816 89.4035 230.212C89.36 231.319 89.3793 233.011 89.6838 235.485C90.1091 235.553 90.5393 235.621 90.9646 235.693C91.0709 233.944 91.1193 232.112 91.0951 230.198C91.0854 229.57 91.0709 228.946 91.0468 228.337C91.2449 227.153 91.4093 225.858 91.5108 224.461C91.5833 223.422 91.6171 222.436 91.6171 221.513C91.0371 221.595 90.462 221.677 89.8868 221.764Z"
					fill="#EFC7B0"
				/>
				<path
					d="M91.2353 221.402C90.9839 220.755 90.6118 220.32 90.3701 220.078C89.7805 220.595 89.3262 223.379 89.3262 223.379C89.3262 223.379 90.3701 224.278 91.4963 224.128C91.7621 223.969 91.3561 223.205 91.6219 223.041C91.6703 222.683 91.5543 222.229 91.2353 221.402Z"
					fill="#FFAB00"
				/>
				<path
					d="M92.1198 216.714C92.0666 217.526 91.999 218.575 91.9458 219.807C94.2609 219.778 96.5808 219.744 98.8959 219.715C98.5479 219.387 97.9872 218.768 97.6634 217.835C97.0351 216.023 97.7698 214.423 97.9486 214.065C98.1806 214.089 98.4174 214.114 98.6494 214.143C98.6977 213.886 98.7606 213.379 98.5817 212.78C98.5286 212.591 98.3642 212.103 97.9727 211.673C97.1511 210.774 95.7398 210.585 94.6669 210.933C93.8452 211.199 93.3378 211.736 93.1686 211.929C92.5161 212.673 92.3373 213.529 92.1198 216.714Z"
					fill="#FF8F73"
				/>
				<path
					d="M92.0039 255.925C92.0281 256.278 92.0281 256.321 92.0377 257.061C92.0474 257.906 91.8976 258.095 92.0812 258.337C92.3084 258.641 92.8594 258.757 93.217 258.564C93.3088 258.515 93.4732 258.399 93.7777 257.249C93.9613 256.558 93.9806 256.21 93.9855 255.925C94.0096 255.026 93.5167 254.881 92.9947 254.881C92.4582 254.881 91.9652 255.326 92.0039 255.925Z"
					fill="#344563"
				/>
				<path
					d="M102.985 257.375C103.081 257.143 102.893 256.853 102.849 256.785C102.777 256.669 102.68 256.578 102.173 256.288C101.627 255.978 101.351 255.49 101.245 255.292C101.032 254.9 100.525 254.804 100.476 254.794C100.206 254.746 99.9205 254.804 99.6692 254.949C99.3502 255.128 99.4566 255.48 99.4517 255.848C99.4517 255.853 99.4517 255.853 99.4517 255.857C99.4421 256.307 99.4179 256.718 99.8335 256.882C99.8867 256.901 99.9447 256.925 100.003 256.94C100.264 257.017 100.317 256.988 100.568 257.051C101.192 257.215 101.235 257.52 101.723 257.66C102.202 257.81 102.849 257.699 102.985 257.375Z"
					fill="#344563"
				/>
				<path
					d="M94.261 250.087C94.058 251.914 93.8792 253.871 93.6762 255.142C93.6472 255.326 93.5409 255.485 93.3862 255.582C93.3862 255.582 93.3862 255.582 93.3814 255.582C93.2557 255.655 93.1929 255.693 93.1059 255.717C93.0721 255.727 92.7869 255.8 92.5356 255.626C92.4728 255.582 92.4341 255.539 92.4051 255.505C92.2746 252.764 92.1344 251.165 92.1393 251.034L92.1441 250.802C92.1489 250.585 92.1586 250.449 92.1683 249.976L94.261 250.087Z"
					fill="#36B37E"
				/>
				<path
					d="M92.1633 249.994C92.1778 248.453 92.1971 246.191 92.2116 243.436C92.2261 240.55 92.2358 239.105 92.2261 238.902C92.0811 235.785 91.5301 231.682 91.9361 229.966C92.0424 229.516 92.4436 228.255 92.5741 227.849C92.6127 227.728 92.6804 227.525 92.8012 227.269C92.9172 227.022 93.0381 226.815 93.1541 226.641C93.2749 226.689 93.4682 226.761 93.7147 226.834C93.9274 226.892 94.0917 226.921 94.1787 226.945C94.6765 227.061 95.6335 227.254 98.2144 227.665C98.3159 227.825 98.4705 228.076 98.6445 228.39C98.6445 228.39 99.2873 229.55 99.7658 230.952C100.186 232.194 100.81 236.017 100.757 241.208C100.935 243.383 101.051 245.703 101.076 248.148C101.085 249.134 101.08 250.101 101.066 251.048L99.1278 251.063C98.7654 247.689 98.1805 244.006 97.2767 240.082C96.7838 237.941 96.2376 235.915 95.6625 234.006C95.3241 237.559 95.0052 241.14 94.6958 244.746C94.546 246.529 94.3962 248.313 94.2512 250.086L92.1633 249.994Z"
					fill="#FFAB00"
				/>
				<path
					d="M98.7026 218.797C98.6881 218.792 98.6785 218.792 98.664 218.787C97.4557 218.536 96.8564 218.357 96.7307 218.193C96.3682 217.739 96.9385 217.047 96.5954 216.695C96.3682 216.463 95.909 216.545 95.5272 216.661C94.8651 216.279 94.5606 216.322 94.4011 216.429C93.8888 216.772 94.5703 218.048 93.9468 218.657C93.4538 219.135 92.4823 218.874 92.4388 219.126C92.4195 219.242 92.6128 219.372 92.7772 219.464C93.3475 220.116 94.3479 221.436 94.8409 223.388C95.2372 224.964 95.1406 226.308 95.0149 227.115C95.4064 227.294 96.1942 227.589 97.1947 227.497C97.736 227.448 98.1758 227.303 98.4851 227.168C98.4078 226.559 98.3595 225.689 98.5045 224.66C98.5963 224.012 98.6688 223.514 98.8621 223.234C98.3546 221.885 98.7413 220.3 98.7026 218.797Z"
					fill="#E4B69D"
				/>
				<path
					d="M98.4462 214.118C98.4027 214.278 98.3641 214.432 98.3206 214.592C98.3447 214.616 98.3834 214.664 98.4366 214.718C98.6009 214.892 98.7169 214.969 98.7024 215.051C98.6975 215.066 98.6927 215.08 98.683 215.09C98.596 215.196 98.2916 215.259 98.2287 215.355C98.2191 215.384 97.9967 216.332 97.9871 216.361C97.9822 216.37 97.9291 216.612 97.8759 216.82C97.8324 217.004 97.6826 217.149 97.4941 217.178C97.1509 217.231 96.7111 217.26 96.2133 217.211C95.5415 217.144 95.0099 216.95 94.6619 216.796C94.5169 216.366 94.5797 216.109 94.657 215.96C94.8987 215.486 95.4448 215.631 95.7348 215.133C95.9185 214.814 95.8943 214.505 96.165 214.379C96.2761 214.326 96.3293 214.355 96.5275 214.345C97.0156 214.316 97.1751 214.099 97.5714 214.022C97.7648 213.988 98.0547 213.973 98.4462 214.118Z"
					fill="#EFC7B0"
				/>
				<path
					d="M101.08 250.125C101.076 251.846 101.042 253.76 100.916 255.301C100.829 255.354 100.481 255.548 100.008 255.49H100.003C99.7997 255.466 99.645 255.292 99.6402 255.084C99.5822 253.407 99.2439 251.676 99.0747 250.241L101.08 250.125Z"
					fill="#36B37E"
				/>
				<path
					d="M101.187 255.5C101.187 255.5 101.346 255.795 101.535 255.974C101.612 256.046 101.583 256.114 101.525 256.162C101.414 256.264 101.24 256.264 101.119 256.172L100.544 255.732C100.631 255.732 100.781 255.722 100.94 255.65C101.051 255.606 101.129 255.548 101.187 255.5Z"
					fill="#57D9A3"
				/>
				<path
					d="M93.391 256.215L92.4243 256.182L92.5258 256.766H93.2025L93.391 256.215Z"
					fill="#57D9A3"
				/>
				<path
					d="M99.6544 219.218C99.2726 219.551 98.7796 220.054 98.3253 220.755C97.8806 221.441 97.6293 222.084 97.4795 222.567C97.5665 222.644 97.6535 222.736 97.7405 222.847C98.0111 223.2 98.1175 223.558 98.1658 223.8C98.9923 223.408 99.8767 222.915 100.708 222.524C100.665 222.098 100.529 221.721 100.394 221.204C100.191 220.412 99.9154 219.749 99.6544 219.218Z"
					fill="#FFAB00"
				/>
				<path
					d="M99.6498 219.207C99.6063 219.178 99.5386 219.135 99.4516 219.082C99.1375 218.893 98.7315 218.705 97.7214 218.434C97.4652 218.366 97.1269 218.279 96.7257 218.192C96.7064 218.444 96.6581 218.734 96.5711 219.048C96.3922 219.681 96.1071 220.164 95.8751 220.488C95.2564 219.869 94.9085 218.975 94.1013 218.294C92.9172 218.468 92.0472 218.942 91.6364 219.178C91.1434 219.454 90.7229 219.768 90.3701 220.077C90.6118 220.314 91.0323 220.802 91.2884 221.542C91.5542 222.31 91.5107 222.977 91.4624 223.311C91.3948 223.987 91.4624 224.504 91.5349 224.843C91.6702 225.486 91.8781 225.8 92.1922 226.684C92.4 227.274 92.5305 227.762 92.603 228.062C94.546 228.042 96.4889 228.028 98.4318 228.009C98.5478 227.549 98.6735 227.153 98.7846 226.839C99.0988 225.954 99.2003 225.679 99.3888 224.968C99.5241 224.456 99.5918 224.205 99.6256 223.881C99.6788 223.369 99.6159 223.161 99.5966 222.243C99.5918 221.977 99.5918 221.692 99.5966 221.121C99.6111 220.604 99.6208 219.956 99.6498 219.207Z"
					fill="#FFC400"
				/>
				<path
					d="M95.0778 218.396C95.1358 217.212 95.0343 217.154 95.0972 216.308C95.218 214.79 95.5998 214.312 95.334 214.046C94.928 213.65 93.4539 214.162 92.5404 215.133C91.0035 216.762 90.8295 219.904 92.1586 220.803C92.8884 221.296 94.1402 221.17 94.696 220.546C94.986 220.223 95.0198 219.609 95.0778 218.396Z"
					fill="#FF8F73"
				/>
				<path
					d="M134.438 254.601L133.245 256.119L131.393 257.057L131.384 257.235L134.999 257.081L135.192 256.448L135.381 257.061L135.772 257.086L136.202 254.311L134.226 254.205L134.438 254.601Z"
					fill="#A5ADBA"
				/>
				<path
					d="M132.128 231.542C132.273 235.36 132.544 239.41 132.989 243.664C133.385 247.433 133.878 251.015 134.439 254.398C134.903 254.451 135.367 254.509 135.831 254.562C135.594 252.561 135.381 250.502 135.197 248.39C134.999 246.109 134.845 243.886 134.729 241.725C134.854 238.753 134.975 235.776 135.101 232.803L132.128 231.542Z"
					fill="#B3BAC5"
				/>
				<path
					d="M138.092 234.863C139.053 234.863 139.832 234.084 139.832 233.123C139.832 232.162 139.053 231.383 138.092 231.383C137.132 231.383 136.353 232.162 136.353 233.123C136.353 234.084 137.132 234.863 138.092 234.863Z"
					fill="#A5ADBA"
				/>
				<path
					d="M134.458 231.668C134.448 232.432 134.41 233.519 134.279 234.824C134.24 235.187 134.211 235.438 134.202 235.534C133.912 237.966 134.366 241.818 134.511 243.33C134.666 244.983 134.84 246.66 135.028 248.357C135.284 250.657 135.57 252.91 135.869 255.114C136.333 255.08 136.802 255.051 137.266 255.017C137.735 253.321 138.146 251.073 138.097 248.429C138.073 247.168 137.947 246.027 137.778 245.017C138.01 244.292 138.32 243.277 138.648 242.05C139.368 239.358 139.857 237.477 139.939 235.075C139.968 234.23 139.953 233.181 139.813 231.972C138.03 231.871 136.246 231.769 134.458 231.668Z"
					fill="#C1C7D0"
				/>
				<path
					d="M136.203 254.311C136.72 254.306 137.232 254.297 137.749 254.292C137.658 254.456 137.571 254.65 137.503 254.872C137.266 255.655 137.416 256.351 137.527 256.713C137.542 256.829 137.556 256.95 137.571 257.066L136.889 257.095L135.415 257.158L135.43 256.844L135.729 256.38C135.647 255.684 135.565 254.993 135.483 254.297C135.729 254.297 135.966 254.302 136.203 254.311Z"
					fill="#A5ADBA"
				/>
				<path
					d="M128.871 219.517C128.856 219.44 128.721 218.512 129.219 218.125C129.605 217.821 129.968 218.14 130.49 217.821C130.823 217.613 130.968 217.299 131.254 216.666C131.577 215.95 131.548 215.665 131.722 215.24C131.906 214.786 132.302 214.172 133.279 213.601C133.221 213.427 133.163 213.162 133.24 212.876C133.438 212.127 134.366 211.852 134.632 211.774C135.594 211.489 136.454 211.828 136.85 211.992C138.798 212.789 139.518 214.732 139.576 214.897C140.108 216.409 139.687 217.729 139.397 218.647C139.117 219.541 138.745 220.716 137.677 221.591C135.391 223.456 132.09 222.156 131.655 221.982C131.08 221.76 129.103 220.982 128.871 219.517Z"
					fill="#7A869A"
				/>
				<path
					d="M132.5 222.789C132.873 222.929 132.911 223.91 132.887 225.22C132.863 226.752 132.728 228.13 132.554 229.309C132.94 229.347 133.327 229.391 133.723 229.425C134.622 229.512 135.507 229.584 136.382 229.647C136.179 228.671 135.884 226.564 136.696 224.118C137.329 222.219 138.363 220.923 139.011 220.227C139.325 220.077 139.378 219.971 139.373 219.903C139.344 219.497 137.213 219.295 135.758 219.28C134.579 219.27 133.989 219.265 133.279 219.464"
					fill="#8E572A"
				/>
				<path
					d="M134.207 213.398C133.931 213.93 133.757 214.863 133.709 215.332C133.704 215.414 133.709 215.453 133.588 215.578C133.467 215.709 133.279 215.805 133.351 215.902C133.428 215.999 133.694 216.071 133.747 216.163L134.042 217.768L134.738 217.806L135.816 217.864C136.362 217.589 136.478 217.429 136.459 217.333C136.42 217.154 135.917 217.27 135.507 216.902C135.478 216.878 135.11 216.545 135.12 216.091C135.125 215.772 135.313 215.772 135.313 215.511C135.309 215.245 135.091 215.022 134.414 214.206C134.371 214.152 134.342 214.109 134.323 214.065C134.274 213.964 134.269 213.877 134.265 213.78C134.25 213.688 134.236 213.558 134.207 213.398Z"
					fill="#8E572A"
				/>
				<path
					d="M131.21 221.909C130.703 223.427 130.572 224.645 130.553 225.481C130.538 226.109 130.582 226.501 130.553 227.646C130.524 228.806 130.451 229.623 130.422 230C130.34 231.059 130.297 232.682 130.49 235.075C130.896 235.157 131.302 235.239 131.713 235.321C131.882 233.649 131.998 231.89 132.046 230.053C132.061 229.449 132.07 228.85 132.07 228.265C132.307 227.134 132.515 225.897 132.665 224.563C132.776 223.572 132.844 222.625 132.877 221.735C132.322 221.793 131.766 221.851 131.21 221.909Z"
					fill="#8E572A"
				/>
				<path
					d="M133.559 219.319C133.1 219.575 132.554 219.957 132.037 220.523C130.572 222.123 130.398 224.051 130.374 224.761C130.524 224.877 130.775 225.037 131.118 225.134C131.568 225.264 131.954 225.216 132.157 225.177C132.085 224.583 132.017 223.988 131.945 223.394C132.481 222.036 133.023 220.677 133.559 219.319Z"
					fill="#DFE1E5"
				/>
				<path
					d="M139.296 223.055L143.554 227.545C143.017 228.034 142.452 228.599 141.872 229.247C141.258 229.938 140.736 230.61 140.296 231.233C140.306 231.615 140.321 231.992 140.33 232.374C140.717 232.156 141.142 231.992 141.737 231.663C142.336 231.325 143.09 230.88 143.834 230.175C144.26 229.774 144.859 229.111 145.391 228.121C145.526 227.869 145.545 227.57 145.444 227.304C144.96 226.076 144.153 224.496 142.776 222.954C142.109 222.205 141.437 221.61 140.818 221.132C140.311 221.77 139.803 222.413 139.296 223.055Z"
					fill="#8E572A"
				/>
				<path
					d="M143.017 223.224C142.756 222.736 140.606 220.237 139.852 219.957C139.533 221.011 139.218 222.059 138.899 223.113C139.025 223.186 139.209 223.292 139.421 223.442C139.726 223.654 139.939 223.848 140.214 224.099C140.349 224.22 140.741 224.602 140.741 224.602C140.741 224.602 142.766 223.553 143.017 223.224Z"
					fill="#DFE1E5"
				/>
				<path
					d="M140.301 231.233L138.88 230.929L137.648 231.248L137.658 232.606L139.262 232.789L140.495 232.287L140.301 231.233Z"
					fill="#8E572A"
				/>
				<path
					d="M134.651 217.439C134.487 217.656 134.598 217.859 134.555 218.27C134.521 218.565 134.41 218.98 134.038 219.464C134.279 219.599 134.767 219.831 135.42 219.846C136.261 219.865 136.87 219.517 137.102 219.367C136.981 219.324 136.778 219.227 136.652 219.024C136.618 218.966 136.517 218.787 136.57 218.202C136.614 217.704 136.749 217.613 136.667 217.453C136.531 217.187 136.063 217.173 135.724 217.168C135.347 217.158 134.874 217.144 134.651 217.439Z"
					fill="#8E572A"
				/>
				<path
					d="M139.383 224.853C139.475 224.587 140.195 222.63 140.195 222.63V222.625C140.5 221.987 140.814 221.45 141.089 221.025C140.794 220.672 140.297 220.16 139.538 219.783C138.972 219.498 138.431 219.377 137.711 219.29C137.687 219.285 137.663 219.285 137.638 219.28C137.305 219.561 136.976 219.846 136.643 220.126C136.652 220.44 136.715 220.561 136.744 220.605C136.875 220.822 137.092 220.924 137.223 220.972C136.976 221.131 136.324 221.504 135.43 221.484C134.734 221.47 134.212 221.223 133.956 221.078C134.158 220.817 134.289 220.576 134.371 220.358C134.101 220.01 133.825 219.662 133.554 219.314C133.284 219.793 132.912 220.498 132.525 221.383C132.003 222.576 131.742 223.176 131.723 223.775C131.684 224.921 132.095 225.133 132.457 226.636C132.578 227.153 132.51 227.748 132.365 228.937C132.264 229.763 132.066 230.909 131.621 232.257C133.269 232.75 134.642 232.929 135.599 232.992C136.744 233.069 137.315 232.987 137.653 232.6C138.03 232.17 137.904 231.61 138.378 231.266C138.726 231.015 139.17 231.044 139.465 231.097C138.774 227.729 139.011 225.907 139.383 224.853Z"
					fill="#DFE1E5"
				/>
				<path
					d="M129.92 235.433C129.92 235.433 129.9 235.863 129.847 236.341C129.794 236.82 130.06 237.695 130.258 238.052C130.456 238.41 130.63 238.676 130.867 238.758C131.104 238.835 131.007 238.651 131.167 238.637C131.326 238.622 131.452 238.526 131.452 238.526C131.452 238.526 131.452 237.956 131.452 237.496C131.452 237.037 131.452 236.858 131.452 236.858C131.452 236.858 131.592 237.83 131.693 237.844C131.79 237.859 131.848 237.757 131.848 237.757C131.848 237.757 132.046 237.071 131.93 236.414C131.814 235.756 131.22 235.307 131.22 234.959C131.22 234.611 129.92 235.433 129.92 235.433Z"
					fill="#8E572A"
				/>
				<path
					d="M135.884 233.77L135.217 237.197C135.067 237.97 134.39 238.531 133.603 238.531H97.32C96.5322 238.531 95.8556 237.97 95.7057 237.197L95.0388 233.77C94.8889 232.997 94.2123 232.437 93.4245 232.437H84.4977C83.444 232.437 82.6659 233.408 82.8882 234.437L89.7948 266.041C90.4279 268.937 92.9895 271 95.9571 271H134.714C137.677 271 140.243 268.937 140.876 266.041L147.783 234.437C148.005 233.413 147.227 232.437 146.174 232.437H137.513C136.715 232.437 136.034 232.997 135.884 233.77Z"
					fill="url(#paint31_linear_1331_7994)"
				/>
				<path
					d="M125.874 24.9388C126.585 24.4652 126.938 24.2235 127.199 24.1752C127.75 24.0737 127.75 24.354 128.895 24.4362C129.359 24.47 129.553 24.4362 129.698 24.6005C129.944 24.8712 129.896 25.4801 129.577 25.7121C129.417 25.8281 129.238 25.8233 128.958 25.8136C128.799 25.8088 128.692 25.7895 128.122 25.6493C127.523 25.5043 127.532 25.4995 127.479 25.4995C127.126 25.4995 126.972 25.6396 126.604 25.5961C126.459 25.5816 126.338 25.5381 126.266 25.5091C126.227 25.5333 126.121 25.5961 125.976 25.5961C125.821 25.5961 125.715 25.5333 125.676 25.5091C125.555 25.5043 125.411 25.485 125.386 25.4125C125.353 25.3158 125.565 25.1466 125.874 24.9388Z"
					fill="#B08874"
				/>
				<path
					d="M105.072 218.541C105.058 218.532 105.034 218.536 105.029 218.536C104.952 218.551 103.869 218.971 103.932 219.247C103.937 219.271 103.975 219.402 103.975 219.402C104.019 219.489 104.057 219.488 104.067 219.542C104.086 219.633 103.985 219.682 104.009 219.764C104.024 219.822 104.082 219.822 104.101 219.885C104.12 219.943 104.096 219.991 104.086 220.025C104.053 220.17 104.183 220.349 104.251 220.402C104.526 220.619 105.406 220.199 105.459 219.749C105.474 219.619 105.416 219.488 105.459 219.179C105.478 219.049 105.493 219.025 105.474 218.967C105.411 218.793 105.106 218.662 105.092 218.575C105.092 218.58 105.092 218.551 105.072 218.541Z"
					fill="#E4B69D"
				/>
				<path
					d="M169.175 145.043L168.136 144.613L177.507 122.124L178.546 122.554L169.175 145.043Z"
					fill="url(#paint32_linear_1331_7994)"
				/>
				<path
					d="M192.364 184.245C192.181 182.51 191.659 180.871 190.818 179.378C189.977 177.884 188.817 176.541 187.367 175.381C185.922 174.221 184.206 173.312 182.263 172.679C180.243 172.022 178.189 171.761 176.159 171.901C174.129 172.041 172.2 172.549 170.432 173.404C168.663 174.264 167.068 175.487 165.69 177.039C164.313 178.595 163.254 180.494 162.544 182.684C161.853 184.806 161.597 186.889 161.775 188.88C161.954 190.871 162.529 192.737 163.477 194.414C164.424 196.091 165.729 197.584 167.358 198.86C168.982 200.131 170.915 201.137 173.099 201.847C173.8 202.074 174.578 202.248 175.41 202.369C176.241 202.485 177.082 202.543 177.908 202.538C178.74 202.534 179.552 202.461 180.33 202.326C181.113 202.19 181.833 201.987 182.476 201.722C182.606 201.668 182.679 201.523 182.635 201.383L181.63 198.073C181.611 198 181.557 197.942 181.495 197.908C181.427 197.874 181.354 197.865 181.282 197.889C180.079 198.261 178.88 198.416 177.72 198.338C176.55 198.261 175.444 198.058 174.438 197.729C172.78 197.188 171.364 196.439 170.229 195.501C169.093 194.564 168.213 193.486 167.619 192.287C167.019 191.093 166.681 189.779 166.609 188.382C166.536 186.985 166.739 185.531 167.213 184.071C167.73 182.486 168.469 181.118 169.417 179.997C170.364 178.875 171.451 177.991 172.66 177.367C173.863 176.744 175.192 176.381 176.608 176.29C178.024 176.198 179.489 176.391 180.948 176.865C182.268 177.295 183.438 177.894 184.433 178.658C185.424 179.417 186.217 180.301 186.787 181.287C187.357 182.273 187.71 183.356 187.831 184.511C187.952 185.666 187.812 186.879 187.41 188.116C187.13 188.972 186.782 189.726 186.366 190.354C185.956 190.977 185.506 191.485 185.037 191.862C184.573 192.234 184.1 192.495 183.636 192.635C183.191 192.771 182.78 192.775 182.389 192.645C182.147 192.568 181.992 192.432 181.91 192.229C181.823 192.007 181.814 191.799 181.881 191.591C181.954 191.374 182.002 191.272 182.041 191.214L186.879 182.863C186.922 182.79 186.927 182.703 186.898 182.626C186.869 182.548 186.806 182.486 186.724 182.461L182.92 181.224C182.795 181.186 182.659 181.239 182.592 181.35L182.186 182.075C182.021 181.572 181.736 181.123 181.325 180.731C180.736 180.171 180.093 179.769 179.416 179.552C178.421 179.228 177.386 179.127 176.347 179.252C175.313 179.378 174.313 179.707 173.385 180.233C172.457 180.76 171.611 181.485 170.871 182.384C170.132 183.288 169.552 184.371 169.151 185.608C168.837 186.57 168.701 187.517 168.745 188.421C168.788 189.32 168.972 190.161 169.296 190.915C169.62 191.673 170.088 192.34 170.693 192.891C171.954 194.047 173.81 194.617 175.598 194.385C176.362 194.283 177.053 194.018 177.657 193.583C177.734 194.032 177.923 194.501 178.218 194.975C178.643 195.661 179.416 196.188 180.509 196.545L180.663 196.594C181.664 196.893 182.737 196.961 183.844 196.801C184.946 196.642 186.018 196.26 187.038 195.67C188.053 195.081 188.996 194.254 189.827 193.22C190.663 192.186 191.325 190.934 191.789 189.508C192.355 187.754 192.548 185.985 192.364 184.245ZM179.581 186.797C179.122 188.131 178.455 189.131 177.604 189.764C176.773 190.388 175.966 190.557 175.139 190.291C174.414 190.054 173.984 189.653 173.824 189.054C173.655 188.426 173.708 187.672 173.989 186.816C174.172 186.251 174.424 185.743 174.733 185.308C175.038 184.873 175.395 184.516 175.787 184.25C176.173 183.989 176.594 183.815 177.043 183.737C177.488 183.66 177.952 183.699 178.421 183.853C179.054 184.061 179.455 184.409 179.644 184.917C179.837 185.444 179.818 186.077 179.581 186.797Z"
					fill="url(#paint33_radial_1331_7994)"
				/>
				<path
					d="M119.558 116.064C117.706 102.458 105.179 92.9226 91.5736 94.7737L63.5364 98.5823C49.9311 100.433 40.3953 112.961 42.2464 126.566C44.0975 140.172 56.625 149.707 70.2304 147.856C74.0341 147.339 77.8329 148.804 80.3075 151.737L82.4051 154.222L83.7632 151.269C85.363 147.784 88.6399 145.358 92.4387 144.84L98.2627 144.048C111.873 142.202 121.404 129.669 119.558 116.064Z"
					fill="url(#paint34_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M54.1503 111.463C51.7965 111.492 49.5249 111.153 47.3887 110.501C49.5491 111.777 51.9705 112.797 54.6722 113.367C65.2085 115.595 75.3147 110.124 81.0226 107.031C87.7455 103.391 87.2526 101.825 92.2404 99.9307C98.8763 97.4078 104.845 98.244 109.384 99.1913C104.405 95.6292 98.1175 93.8796 91.5734 94.7689L74.5993 97.0743C71.4868 105.378 63.5411 111.342 54.1503 111.463Z"
					fill="url(#paint35_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M80.8538 131.429C70.709 129.442 63.0823 122.69 51.241 124.947C47.9593 125.576 45.0546 126.765 42.5269 128.19C43.2663 131.82 44.7694 135.126 46.8525 137.953C48.7761 136.938 50.8979 136.078 53.2371 135.508C64.9189 132.637 72.8839 138.944 83.0819 140.413C86.7647 136.17 92.3422 133.666 98.374 134.145L107.837 134.899C111.08 133.13 114.551 130.878 118.243 128.036C119.335 125.083 119.886 121.888 119.775 118.592C101.868 131.931 89.2587 133.072 80.8538 131.429Z"
					fill="url(#paint36_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M113.971 135.386C115.798 133.207 117.243 130.722 118.238 128.035C114.546 130.877 111.076 133.129 107.833 134.898L113.971 135.386Z"
					fill="url(#paint37_linear_1331_7994)"
				/>
				<path
					d="M113.971 135.386C115.798 133.207 117.243 130.722 118.238 128.035C114.546 130.877 111.076 133.129 107.833 134.898L113.971 135.386Z"
					fill="url(#paint38_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M53.2323 135.508C50.8978 136.083 48.7713 136.938 46.8477 137.953C52.0675 145.039 60.8928 149.127 70.2305 147.856C73.2995 147.441 76.3686 148.315 78.7417 150.21C79.1911 146.455 80.7571 143.086 83.077 140.408C72.8742 138.944 64.9092 132.637 53.2323 135.508Z"
					fill="url(#paint39_linear_1331_7994)"
				/>
				<path
					d="M53.2323 135.508C50.8978 136.083 48.7713 136.938 46.8477 137.953C52.0675 145.039 60.8928 149.127 70.2305 147.856C73.2995 147.441 76.3686 148.315 78.7417 150.21C79.1911 146.455 80.7571 143.086 83.077 140.408C72.8742 138.944 64.9092 132.637 53.2323 135.508Z"
					fill="url(#paint40_linear_1331_7994)"
				/>
				<path
					d="M45.8472 109.965C46.3498 110.163 46.8621 110.342 47.3841 110.501C46.925 110.23 46.4803 109.95 46.0453 109.66C45.9825 109.762 45.9148 109.863 45.8472 109.965Z"
					fill="#DFE1E5"
				/>
				<path
					opacity="0.5"
					d="M74.5949 97.0791L63.5318 98.5822C56.079 99.5972 49.8539 103.817 46.0454 109.66C46.4804 109.95 46.925 110.23 47.3842 110.501C49.5205 111.153 51.792 111.492 54.1458 111.463C63.5414 111.342 71.4872 105.378 74.5949 97.0791Z"
					fill="url(#paint41_linear_1331_7994)"
				/>
				<path
					d="M74.5949 97.0791L63.5318 98.5822C56.079 99.5972 49.8539 103.817 46.0454 109.66C46.4804 109.95 46.925 110.23 47.3842 110.501C49.5205 111.153 51.792 111.492 54.1458 111.463C63.5414 111.342 71.4872 105.378 74.5949 97.0791Z"
					fill="#0065FF"
				/>
				<path
					opacity="0.5"
					d="M107.832 134.898L98.3688 134.144C92.337 133.666 86.7595 136.165 83.0767 140.413C83.1008 140.418 83.1202 140.423 83.1443 140.423C89.2196 141.283 97.378 140.601 107.832 134.898Z"
					fill="url(#paint42_linear_1331_7994)"
				/>
				<path
					opacity="0.6"
					d="M107.832 134.898L98.3688 134.144C92.337 133.666 86.7595 136.165 83.0767 140.413C83.1008 140.418 83.1202 140.423 83.1443 140.423C89.2196 141.283 97.378 140.601 107.832 134.898Z"
					fill="#0065FF"
				/>
				<path
					opacity="0.5"
					d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z"
					fill="url(#paint43_linear_1331_7994)"
				/>
				<path
					d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z"
					fill="url(#paint44_linear_1331_7994)"
				/>
				<path
					d="M83.1447 140.423C83.1205 140.418 83.1012 140.413 83.077 140.413C80.7571 143.091 79.1912 146.459 78.7417 150.215C79.3072 150.669 79.834 151.177 80.3125 151.742L82.4101 154.226L83.7682 151.273C85.368 147.789 88.6448 145.362 92.4437 144.845L98.2677 144.052C104.652 143.187 110.138 139.968 113.975 135.391L107.837 134.903C97.3784 140.602 89.22 141.283 83.1447 140.423Z"
					fill="#0065FF"
				/>
				<g opacity="0.8">
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M97.4532 112.195L63.311 116.64L63.4957 118.058L97.6379 113.613L97.4532 112.195Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M98.1007 117.163L63.9585 121.608L64.1432 123.027L98.2854 118.582L98.1007 117.163Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M98.7477 122.131L64.6055 126.576L64.7902 127.995L98.9323 123.55L98.7477 122.131Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M84.0192 129.105L65.2563 131.548L65.441 132.966L84.2039 130.524L84.0192 129.105Z"
							fill="#B2D4FF"
						/>
					</g>
				</g>
				<path
					d="M82.4097 154.699C81.6074 164.781 89.1326 173.607 99.2146 174.409L103.531 174.752C106.348 174.975 108.857 176.627 110.176 179.126L111.297 181.243L112.738 179.329C114.439 177.072 117.175 175.84 119.992 176.062C130.074 176.864 138.9 169.339 139.702 159.257C140.504 149.175 132.979 140.35 122.897 139.548L102.124 137.895C92.0374 137.092 83.212 144.617 82.4097 154.699Z"
					fill="url(#paint45_radial_1331_7994)"
				/>
				<path
					d="M104.226 138.064L102.119 137.894C94.7535 137.31 88.0692 141.166 84.6812 147.218L87.4602 147.082C94.3861 146.734 100.413 143.245 104.226 138.064Z"
					fill="url(#paint46_linear_1331_7994)"
				/>
				<path
					d="M122.892 139.548L108.436 138.397C107.909 139.519 107.46 140.693 107.097 141.911C103.183 155.072 110.679 168.919 123.84 172.834C125.318 173.274 126.667 174.013 127.817 174.97C134.289 172.563 139.117 166.589 139.702 159.253C140.499 149.171 132.974 140.35 122.892 139.548Z"
					fill="#00C7E5"
				/>
				<g opacity="0.3">
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M97.8656 149.122L97.7368 150.392L126.944 153.354L127.072 152.084L97.8656 149.122Z"
							fill="#B3F5FF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M97.432 153.372L97.3032 154.642L126.51 157.604L126.639 156.334L97.432 153.372Z"
							fill="#B3F5FF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M97.0033 157.622L96.8745 158.892L126.081 161.854L126.21 160.584L97.0033 157.622Z"
							fill="#B3F5FF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M96.5721 161.878L96.4434 163.147L115.557 165.086L115.686 163.816L96.5721 161.878Z"
							fill="#B3F5FF"
						/>
					</g>
				</g>
				<path
					d="M187.879 164.163C191.794 151.003 184.298 137.156 171.137 133.241L144.018 125.174C130.857 121.259 117.01 128.756 113.096 141.916C109.181 155.077 116.677 168.924 129.838 172.839C133.516 173.931 136.377 176.831 137.426 180.523L138.315 183.651L140.77 181.514C143.665 178.996 147.648 178.131 151.326 179.228L156.961 180.905C170.117 184.82 183.959 177.324 187.879 164.163Z"
					fill="url(#paint47_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M134.047 134.898L129.731 134.555C129.557 134.541 129.388 134.521 129.214 134.502C129.427 134.671 129.634 134.84 129.857 135C133.259 137.494 137.087 138.881 140.876 139.62L140.693 139.267C139.368 136.769 136.86 135.121 134.047 134.898Z"
					fill="url(#paint48_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M150.504 136.208C147.687 135.986 144.951 137.218 143.25 139.475L142.887 139.959C148.054 140.679 152.993 140.321 156.478 140.07C164.1 139.519 164.298 137.89 169.624 138.219C176.71 138.654 181.809 141.868 185.549 144.603C182.48 139.306 177.468 135.125 171.137 133.241L164.52 131.273C160.886 134.695 155.874 136.633 150.504 136.208Z"
					fill="url(#paint49_linear_1331_7994)"
				/>
				<path
					d="M146.28 162.235C137.851 156.251 133.68 146.957 121.959 144.139C118.712 143.361 115.575 143.24 112.685 143.501C111.863 147.117 111.868 150.746 112.602 154.183C114.773 154.052 117.063 154.144 119.427 154.584C131.278 156.778 135.937 165.845 144.666 171.379C151.456 175.685 162.597 179.044 181.75 174.53C183.964 172.288 185.776 169.605 187.033 166.551C165.231 171.34 153.264 167.194 146.28 162.235Z"
					fill="url(#paint50_linear_1331_7994)"
				/>
				<path
					d="M144.666 171.374C135.937 165.84 131.283 156.778 119.427 154.579C117.064 154.139 114.773 154.042 112.603 154.178C114.444 162.786 120.804 170.147 129.838 172.834C133.516 173.926 136.377 176.826 137.426 180.519L138.315 183.646L140.77 181.509C143.665 178.991 147.648 178.126 151.326 179.223L156.961 180.9C166.077 183.612 175.516 180.847 181.76 174.525C162.602 179.04 151.456 175.681 144.666 171.374Z"
					fill="url(#paint51_linear_1331_7994)"
				/>
				<path
					d="M144.666 171.374C135.937 165.84 131.283 156.778 119.427 154.579C117.064 154.139 114.773 154.042 112.603 154.178C114.444 162.786 120.804 170.147 129.838 172.834C133.516 173.926 136.377 176.826 137.426 180.519L138.315 183.646L140.77 181.509C143.665 178.991 147.648 178.126 151.326 179.223L156.961 180.9C166.077 183.612 175.516 180.847 181.76 174.525C162.602 179.04 151.456 175.681 144.666 171.374Z"
					fill="url(#paint52_linear_1331_7994)"
				/>
				<path
					opacity="0.9"
					d="M123.52 128.069C122.269 128.872 121.089 129.78 119.997 130.795C122.588 132.796 125.739 134.125 129.214 134.497C126.826 132.617 124.966 130.404 123.52 128.069Z"
					fill="#0065FF"
				/>
				<path
					d="M141.809 141.384L142.887 139.954C142.22 139.862 141.548 139.751 140.876 139.615L141.809 141.384Z"
					fill="#DFE1E5"
				/>
				<path
					opacity="0.5"
					d="M123.521 128.069C124.966 130.403 126.826 132.617 129.214 134.497C129.388 134.516 129.557 134.536 129.731 134.55L134.047 134.893C136.865 135.116 139.373 136.768 140.693 139.267L140.876 139.62C141.548 139.751 142.22 139.862 142.887 139.958L143.249 139.475C144.951 137.218 147.686 135.986 150.504 136.208C155.874 136.633 160.89 134.7 164.52 131.273L144.018 125.174C136.807 123.028 129.398 124.313 123.521 128.069Z"
					fill="url(#paint53_linear_1331_7994)"
				/>
				<path
					opacity="0.8"
					d="M123.521 128.069C124.966 130.403 126.826 132.617 129.214 134.497C129.388 134.516 129.557 134.536 129.731 134.55L134.047 134.893C136.865 135.116 139.373 136.768 140.693 139.267L140.876 139.62C141.548 139.751 142.22 139.862 142.887 139.958L143.249 139.475C144.951 137.218 147.686 135.986 150.504 136.208C155.874 136.633 160.89 134.7 164.52 131.273L144.018 125.174C136.807 123.028 129.398 124.313 123.521 128.069Z"
					fill="#0065FF"
				/>
				<path
					d="M136.389 141.546L135.973 142.915L168.921 152.914L169.336 151.545L136.389 141.546Z"
					fill="#B2D4FF"
				/>
				<path
					d="M134.933 146.341L134.518 147.71L167.465 157.709L167.88 156.34L134.933 146.341Z"
					fill="#B2D4FF"
				/>
				<path
					d="M133.476 151.135L133.061 152.504L166.008 162.503L166.424 161.134L133.476 151.135Z"
					fill="#B2D4FF"
				/>
				<path
					d="M132.022 155.927L131.607 157.296L149.713 162.791L150.129 161.422L132.022 155.927Z"
					fill="#B2D4FF"
				/>
				<path
					d="M155.801 47.4806C156.565 36.3499 148.165 26.7029 137.029 25.9392L114.096 24.3636C102.965 23.6 93.3182 32 92.5546 43.1356C91.7909 54.2664 100.191 63.9134 111.327 64.677C114.439 64.8897 117.223 66.6828 118.707 69.4232L119.968 71.7431L121.534 69.6165C123.38 67.1032 126.387 65.7113 129.494 65.9288L134.26 66.2574C145.395 67.0162 155.038 58.6114 155.801 47.4806Z"
					fill="url(#paint54_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M126.624 33.9578C132.568 32.1647 132.438 30.8404 136.715 30.1541C142.414 29.2406 147.024 30.8839 150.475 32.387C147.102 28.7331 142.38 26.3069 137.029 25.9396L114.096 24.364C107.997 23.9435 102.352 26.2827 98.3594 30.3039C100.061 32.039 102.12 33.5808 104.613 34.6731C112.632 38.1771 121.573 35.4802 126.624 33.9578Z"
					fill="url(#paint55_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M103.758 50.2451C103.83 50.9314 103.85 51.6129 103.835 52.2895C111.211 53.464 116.068 58.4566 122.825 60.878C128.972 63.0868 138.407 63.7682 152.79 56.7843C154.148 54.6142 155.11 52.1638 155.56 49.5201C139.122 57.1952 128.895 56.0304 122.482 53.3431C115.13 50.2596 110.283 44.136 101.438 43.3965C102.68 45.4119 103.502 47.7318 103.758 50.2451Z"
					fill="url(#paint56_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M122.825 60.8786C116.068 58.4571 111.215 53.4645 103.835 52.29C103.767 55.4896 102.757 58.5006 101.046 61.0187C103.97 63.0921 107.484 64.4116 111.322 64.6726C114.434 64.8852 117.218 66.6783 118.702 69.4187L119.963 71.7387L121.529 69.6121C123.376 67.0988 126.382 65.7069 129.49 65.9244L134.255 66.253C141.964 66.7847 148.957 62.9133 152.785 56.7897C138.407 63.7688 128.972 63.0873 122.825 60.8786Z"
					fill="url(#paint57_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M122.825 60.8786C116.068 58.4571 111.215 53.4645 103.835 52.29C103.767 55.4896 102.757 58.5006 101.046 61.0187C103.97 63.0921 107.484 64.4116 111.322 64.6726C114.434 64.8852 117.218 66.6783 118.702 69.4187L119.963 71.7387L121.529 69.6121C123.376 67.0988 126.382 65.7069 129.49 65.9244L134.255 66.253C141.964 66.7847 148.957 62.9133 152.785 56.7897C138.407 63.7688 128.972 63.0873 122.825 60.8786Z"
					fill="url(#paint58_linear_1331_7994)"
				/>
				<path
					opacity="0.8"
					d="M101.438 43.3969C99.674 40.5357 97.0544 38.2883 93.9709 36.9736C93.1976 38.8924 92.7094 40.9562 92.5596 43.1311C92.5306 43.5806 92.5161 44.0252 92.5161 44.4699C94.7635 43.7497 97.2671 43.2809 99.9833 43.3244C100.476 43.3292 100.96 43.3582 101.438 43.3969Z"
					fill="#0052CC"
				/>
				<path
					opacity="0.5"
					d="M99.8282 52.0479C101.254 51.9947 102.578 52.0865 103.835 52.2895C103.849 51.6129 103.83 50.9314 103.758 50.2451C103.497 47.7318 102.68 45.4119 101.433 43.3965C100.959 43.3578 100.476 43.3288 99.9781 43.3192C97.2618 43.2757 94.7583 43.7493 92.5108 44.4646C92.5012 47.4757 93.1537 50.3514 94.3474 52.9468C96.0439 52.4587 97.8757 52.1204 99.8282 52.0479Z"
					fill="url(#paint59_linear_1331_7994)"
				/>
				<path
					opacity="0.6"
					d="M99.8282 52.0479C101.254 51.9947 102.578 52.0865 103.835 52.2895C103.849 51.6129 103.83 50.9314 103.758 50.2451C103.497 47.7318 102.68 45.4119 101.433 43.3965C100.959 43.3578 100.476 43.3288 99.9781 43.3192C97.2618 43.2757 94.7583 43.7493 92.5108 44.4646C92.5012 47.4757 93.1537 50.3514 94.3474 52.9468C96.0439 52.4587 97.8757 52.1204 99.8282 52.0479Z"
					fill="#0052CC"
				/>
				<path
					opacity="0.5"
					d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z"
					fill="url(#paint60_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z"
					fill="url(#paint61_linear_1331_7994)"
				/>
				<path
					opacity="0.8"
					d="M99.8285 52.0486C97.8759 52.1211 96.0441 52.4546 94.3477 52.9476C95.8363 56.181 98.1514 58.9649 101.051 61.019C102.762 58.5009 103.767 55.4898 103.84 52.2903C102.583 52.0921 101.254 51.9954 99.8285 52.0486Z"
					fill="#0052CC"
				/>
				<g opacity="0.8">
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M110.955 38.6885L110.869 39.8501L138.767 41.9202L138.854 40.7586L110.955 38.6885Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M110.653 42.752L110.566 43.9137L138.465 45.9838L138.551 44.8221L110.653 42.752Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M110.351 46.8096L110.265 47.9713L138.163 50.0414L138.25 48.8797L110.351 46.8096Z"
							fill="#B2D4FF"
						/>
					</g>
					<g opacity="0.8">
						<path
							opacity="0.8"
							d="M110.059 50.877L109.973 52.0387L125.306 53.1779L125.392 52.0163L110.059 50.877Z"
							fill="#B2D4FF"
						/>
					</g>
				</g>
				<path
					d="M171.427 93.183L131.171 78.6546C130.736 78.4999 130.514 78.0214 130.669 77.5864L145.197 37.3311C145.352 36.8961 145.83 36.6737 146.265 36.8284L186.521 51.3569C186.956 51.5115 187.178 51.99 187.023 52.425L172.495 92.6804C172.34 93.1154 171.862 93.3377 171.427 93.183Z"
					fill="url(#paint62_linear_1331_7994)"
				/>
				<path
					d="M170.286 89.3662L183.211 53.5568L147.402 40.6318L134.477 76.4412L170.286 89.3662Z"
					fill="#FAFBFC"
				/>
				<path
					d="M141.249 69.9406L152.133 64.8271L157.246 75.7114L141.249 69.9406Z"
					fill="#2684FF"
				/>
				<path
					d="M155.052 59.3747C156.504 59.3747 157.681 58.1975 157.681 56.7455C157.681 55.2934 156.504 54.1162 155.052 54.1162C153.6 54.1162 152.423 55.2934 152.423 56.7455C152.423 58.1975 153.6 59.3747 155.052 59.3747Z"
					fill="#FFAB00"
				/>
				<path
					d="M147.662 72.2553L163.355 64.8848L170.721 80.578L147.662 72.2553Z"
					fill="url(#paint63_linear_1331_7994)"
				/>
				<path
					d="M118.663 128.427L117.537 128.393L119.34 73.2031L120.466 73.237L118.663 128.427Z"
					fill="url(#paint64_linear_1331_7994)"
				/>
				<path
					d="M114.048 108.848C113.246 118.93 120.771 127.755 130.853 128.558L135.169 128.901C137.987 129.123 140.495 130.776 141.814 133.275L142.936 135.392L144.376 133.478C146.077 131.221 148.813 129.988 151.631 130.21C161.712 131.013 170.538 123.488 171.34 113.406C172.142 103.324 164.617 94.4983 154.535 93.6959L133.762 92.043C123.676 91.2407 114.85 98.7659 114.048 108.848Z"
					fill="url(#paint65_radial_1331_7994)"
				/>
				<path
					d="M153.177 111.298C144.821 111.631 142.675 115.242 136.904 113.859C128.736 111.907 128.383 102.941 119.722 100.752C118.794 100.515 117.876 100.365 116.977 100.269C115.348 102.753 114.299 105.672 114.048 108.847C114.014 109.249 114.004 109.645 113.995 110.041C115.087 110.109 116.208 110.259 117.354 110.529C125.715 112.511 128.712 119.128 134.734 123.376C139.809 126.957 148.561 129.925 164.617 126.169C167.778 123.603 170.079 120.002 170.978 115.822C166.768 113.521 160.586 110.998 153.177 111.298Z"
					fill="url(#paint66_linear_1331_7994)"
				/>
				<path
					d="M141.815 133.27L142.936 135.387L144.376 133.473C144.391 133.453 144.405 133.439 144.415 133.419C143.376 133.086 142.336 132.752 141.297 132.424C141.486 132.694 141.66 132.975 141.815 133.27Z"
					fill="url(#paint67_linear_1331_7994)"
				/>
				<path
					d="M134.734 123.371C128.712 119.122 125.715 112.506 117.354 110.524C116.213 110.254 115.087 110.104 113.995 110.036C113.85 119.615 121.167 127.783 130.853 128.552L135.169 128.895C137.653 129.093 139.896 130.403 141.297 132.423C142.336 132.757 143.376 133.09 144.415 133.419C146.116 131.196 148.832 129.983 151.626 130.205C156.507 130.592 161.089 129.026 164.617 126.164C148.562 129.92 139.809 126.952 134.734 123.371Z"
					fill="url(#paint68_linear_1331_7994)"
				/>
				<path
					d="M134.734 123.371C128.712 119.122 125.715 112.506 117.354 110.524C116.213 110.254 115.087 110.104 113.995 110.036C113.85 119.615 121.167 127.783 130.853 128.552L135.169 128.895C137.653 129.093 139.896 130.403 141.297 132.423C142.336 132.757 143.376 133.09 144.415 133.419C146.116 131.196 148.832 129.983 151.626 130.205C156.507 130.592 161.089 129.026 164.617 126.164C148.562 129.92 139.809 126.952 134.734 123.371Z"
					fill="url(#paint69_linear_1331_7994)"
				/>
				<path
					opacity="0.15"
					d="M123.613 94.353C123.613 95.7884 128.311 96.9532 134.106 96.9532C139.901 96.9532 144.598 95.7884 144.598 94.353C144.598 93.7344 143.719 93.164 142.254 92.7146L133.758 92.0379C130.113 91.7479 126.638 92.5502 123.642 94.1645C123.622 94.2273 123.613 94.2902 123.613 94.353Z"
					fill="url(#paint70_linear_1331_7994)"
				/>
				<g opacity="0.3">
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M129.491 103.342L129.377 104.467L158.584 107.429L158.698 106.304L129.491 103.342Z"
							fill="#E6FCFF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M129.06 107.59L128.946 108.715L158.153 111.677L158.267 110.552L129.06 107.59Z"
							fill="#E6FCFF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M128.633 111.846L128.519 112.972L157.725 115.934L157.84 114.809L128.633 111.846Z"
							fill="#E6FCFF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M128.2 116.094L128.085 117.219L147.199 119.157L147.313 118.032L128.2 116.094Z"
							fill="#E6FCFF"
						/>
					</g>
				</g>
				<path
					d="M66.3735 158.151L54.6821 109.756L55.7744 109.495L67.4658 157.885L66.3735 158.151Z"
					fill="url(#paint71_linear_1331_7994)"
				/>
				<path
					d="M50.3131 104.71C62.541 104.71 72.4538 94.7974 72.4538 82.5694C72.4538 70.3414 62.541 60.4287 50.3131 60.4287C38.0851 60.4287 28.1724 70.3414 28.1724 82.5694C28.1724 94.7974 38.0851 104.71 50.3131 104.71Z"
					fill="url(#paint72_linear_1331_7994)"
				/>
				<path
					d="M50.0232 60.4287C47.4616 60.4625 45.0063 60.9362 42.7251 61.7675C45.016 68.9351 52.0773 73.7634 59.8586 72.9611L63.6768 72.5648C66.1707 72.3086 68.6212 73.3429 70.1726 75.31L71.4872 76.9775L71.6515 76.6536C69.0368 67.1855 60.3033 60.2934 50.0232 60.4287Z"
					fill="#FFC400"
				/>
				<path
					d="M39.6511 81.849C40.9537 81.849 42.0096 80.793 42.0096 79.4904C42.0096 78.1878 40.9537 77.1318 39.6511 77.1318C38.3485 77.1318 37.2925 78.1878 37.2925 79.4904C37.2925 80.793 38.3485 81.849 39.6511 81.849Z"
					fill="#FF991F"
				/>
				<path
					d="M50.2939 95.2802C53.2888 95.2802 55.7167 92.8523 55.7167 89.8574C55.7167 86.8624 53.2888 84.4346 50.2939 84.4346C47.299 84.4346 44.8711 86.8624 44.8711 89.8574C44.8711 92.8523 47.299 95.2802 50.2939 95.2802Z"
					fill="#FF991F"
				/>
				<path
					d="M60.8879 81.0902C62.1905 81.0902 63.2465 80.0342 63.2465 78.7316C63.2465 77.429 62.1905 76.373 60.8879 76.373C59.5853 76.373 58.5293 77.429 58.5293 78.7316C58.5293 80.0342 59.5853 81.0902 60.8879 81.0902Z"
					fill="#FF991F"
				/>
				<path
					d="M49.3317 55.4846C50.2548 64.4066 58.2344 70.8878 67.1516 69.9647L70.9697 69.5684C73.4637 69.3122 75.9141 70.3465 77.4655 72.3136L78.7801 73.9811L79.7274 72.0816C80.8439 69.8391 83.0333 68.3263 85.5272 68.0653C94.4492 67.1422 100.93 59.1626 100.007 50.2454C99.0891 41.3234 91.1095 34.8422 82.1875 35.7653L63.8118 37.6647C54.8898 38.583 48.4086 46.5626 49.3317 55.4846Z"
					fill="url(#paint73_radial_1331_7994)"
				/>
				<path
					d="M52.4829 56.4173C60.0903 56.7992 63.7683 62.0866 69.6986 64.8222C74.7009 67.1276 82.811 68.3069 96.2036 62.4539C98.5042 59.7619 99.9252 56.3255 100.08 52.6233C96.0345 51.2555 90.1139 49.9699 83.5601 51.4488C76.3249 53.0825 75.0344 56.572 69.7856 56.3013C62.3522 55.9147 60.6026 48.1526 52.6956 47.6355C51.9319 47.5872 51.1876 47.592 50.4626 47.6403C49.4718 50.0424 49.0465 52.72 49.3317 55.4845C49.3703 55.8374 49.4187 56.1853 49.4767 56.5333C50.4385 56.4125 51.4438 56.3642 52.4829 56.4173Z"
					fill="url(#paint74_linear_1331_7994)"
				/>
				<path
					d="M77.0498 71.8398C77.1948 71.9945 77.335 72.1492 77.4655 72.3135L78.7801 73.9809L79.679 72.1782C78.8042 72.0622 77.9294 71.951 77.0498 71.8398Z"
					fill="url(#paint75_linear_1331_7994)"
				/>
				<path
					d="M79.7322 72.0812C80.8486 69.8386 83.0381 68.3258 85.532 68.0649C89.8528 67.6202 93.5937 65.5129 96.2084 62.4536C82.8157 68.3065 74.7057 67.1272 69.7034 64.8218C63.7731 62.0862 60.0951 56.7988 52.4877 56.4169C51.4485 56.3638 50.4432 56.4121 49.4814 56.5329C50.8927 64.9088 58.5871 70.8536 67.1563 69.9691L70.9745 69.5728C73.2557 69.336 75.5032 70.1866 77.0546 71.8395C77.9294 71.9507 78.809 72.0667 79.6838 72.1779L79.7322 72.0812Z"
					fill="url(#paint76_linear_1331_7994)"
				/>
				<path
					d="M79.7322 72.0812C80.8486 69.8386 83.0381 68.3258 85.532 68.0649C89.8528 67.6202 93.5937 65.5129 96.2084 62.4536C82.8157 68.3065 74.7057 67.1272 69.7034 64.8218C63.7731 62.0862 60.0951 56.7988 52.4877 56.4169C51.4485 56.3638 50.4432 56.4121 49.4814 56.5329C50.8927 64.9088 58.5871 70.8536 67.1563 69.9691L70.9745 69.5728C73.2557 69.336 75.5032 70.1866 77.0546 71.8395C77.9294 71.9507 78.809 72.0667 79.6838 72.1779L79.7322 72.0812Z"
					fill="url(#paint77_linear_1331_7994)"
				/>
				<path
					opacity="0.5"
					d="M60.4478 38.3749C61.1002 39.6461 66.4215 40.1004 72.7771 39.3851C79.0651 38.6746 84.1109 37.07 84.5555 35.6925C83.7774 35.6587 82.9848 35.6829 82.1873 35.765L63.8116 37.6645C62.6468 37.7853 61.5207 38.027 60.4478 38.3749Z"
					fill="#00B8D9"
				/>
				<g opacity="0.3">
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M87.8498 46.0254L61.9092 48.1414L62.0011 49.2686L87.9418 47.1527L87.8498 46.0254Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M88.154 49.8008L62.2134 51.9168L62.3053 53.044L88.246 50.9281L88.154 49.8008Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M88.4636 53.5801L62.5229 55.6961L62.6149 56.8233L88.5557 54.7074L88.4636 53.5801Z"
							fill="#E3FCEF"
						/>
					</g>
					<g opacity="0.3">
						<path
							opacity="0.3"
							d="M79.8074 58.082L62.8315 59.4667L62.9235 60.5939L79.8993 59.2092L79.8074 58.082Z"
							fill="#E3FCEF"
						/>
					</g>
				</g>
				<path
					d="M82.1585 31.0674H80.3848V33.1118H82.1585V31.0674Z"
					fill="url(#paint78_linear_1331_7994)"
				/>
				<path
					d="M70.6849 18.6756C71.2504 18.4098 72.3813 19.1445 72.9517 19.9033C73.1836 20.2126 73.609 20.7732 73.6138 21.5127C73.6186 22.0443 73.4011 22.5567 73.7153 23.0061C73.8023 23.1318 73.8845 23.185 73.9425 23.3445C74.0439 23.649 73.9473 24.0259 73.754 24.2628C73.667 24.3691 73.4591 24.5673 72.3378 24.6639C72.275 24.6687 72.2025 24.6736 72.13 24.6784C71.405 24.7267 70.7526 24.2289 70.6124 23.5136C69.8923 19.8888 70.2257 18.8931 70.6849 18.6756Z"
					fill="#091E42"
				/>
				<path
					d="M68.9688 22.9189L68.5483 24.5236L69.6503 26.4375L72.1587 26.2345L72.1249 24.6879C71.8397 24.7072 71.6271 24.6492 71.5062 24.6009C71.3081 24.5284 71.2404 24.4511 71.2162 24.4172C71.1341 24.3061 71.1341 24.1804 71.1341 24.0886C71.1389 23.7309 71.1776 23.3781 71.2114 23.1509C70.4671 23.0736 69.718 22.9963 68.9688 22.9189Z"
					fill="#CE9E79"
				/>
				<path
					d="M62.0963 37.3213C62.4926 37.36 62.8889 37.3938 63.2853 37.4276C63.6381 37.4808 63.8217 37.5678 63.8411 37.6789C63.8701 37.8529 63.5028 38.0994 62.7294 38.4184C62.6811 38.4667 62.4201 38.7181 62.0866 38.6697C62.019 38.6601 61.961 38.6407 61.9078 38.6117C62.077 38.4619 62.2461 38.3169 62.4153 38.1719C62.4153 38.1188 62.4008 38.0946 62.3863 38.0801C62.2461 37.9158 61.526 38.1091 61.0572 38.4329C60.975 38.4909 60.7769 38.6311 60.6125 38.5731C60.569 38.5586 60.54 38.5296 60.5207 38.5054L60.9412 38.0946C60.8784 38.1236 60.772 38.1623 60.6415 38.2154C60.4482 38.2928 60.3709 38.3218 60.2935 38.2879C60.25 38.2686 60.221 38.2348 60.2065 38.2106L60.9895 37.6354C61.0378 37.5919 61.1055 37.5388 61.2022 37.4856C61.2892 37.4421 61.3762 37.4083 61.5357 37.3793C61.6662 37.3551 61.8595 37.3261 62.0963 37.3213Z"
					fill="#D4B696"
				/>
				<path
					d="M73.0723 29.3711L74.5319 30.6422C74.8751 30.9419 75.3053 31.1304 75.7547 31.1787L79.1041 31.5412L79.0896 32.5078L75.1651 32.532C74.7011 32.5368 74.2468 32.3918 73.8698 32.126L72.3184 31.0385L73.0723 29.3711Z"
					fill="#CE9E79"
				/>
				<path
					d="M72.1735 29.4339C72.2025 29.6417 72.2895 30.1202 72.594 30.56C72.8308 30.9031 73.0967 31.0626 73.2417 31.1351C73.5316 30.763 73.7008 30.5407 73.9908 30.1733C73.7636 29.8157 73.6041 29.1149 73.5316 28.4092C73.4881 27.9791 73.5606 27.9211 73.5365 27.3169C73.5026 26.563 73.4736 25.9105 73.058 25.3692C72.9227 25.1903 72.652 24.91 72.1445 24.707C72.159 26.2826 72.1639 27.8583 72.1735 29.4339Z"
					fill="#57D9A3"
				/>
				<path
					d="M88.4854 43.6488C88.3163 43.557 88.1471 43.4651 87.9779 43.3733C87.7073 43.4748 87.224 43.6826 85.9094 43.0301C85.2714 42.716 84.8751 42.2617 84.6624 41.9717C83.9906 42.165 83.3188 42.3583 82.647 42.5517C82.8886 43.3975 83.1351 44.2433 83.3768 45.0891C83.6571 45.0069 83.9423 44.9247 84.2226 44.8426C84.2226 44.8232 84.1791 44.4173 84.4546 44.2143C84.7204 44.0113 85.1795 44.0741 85.4599 44.4269C86.7358 44.0983 87.2095 43.9919 88.4854 43.6488Z"
					fill="#172B4D"
				/>
				<path
					d="M80.0903 49.8303C80.0275 49.6466 79.9598 49.4678 79.897 49.2841C79.6312 49.1778 79.1333 49.0087 78.5969 47.6409C78.3359 46.9787 78.3455 46.3746 78.3842 46.0218C77.7559 45.7124 77.1276 45.4031 76.4993 45.0986C76.1126 45.8864 75.726 46.6791 75.3345 47.4669C75.6003 47.5974 75.8613 47.7279 76.1271 47.8535C76.1368 47.839 76.3784 47.5104 76.7216 47.5394C77.0551 47.5684 77.3547 47.9212 77.3257 48.3707C78.4954 48.9845 78.9158 49.2213 80.0903 49.8303Z"
					fill="#172B4D"
				/>
				<path
					d="M84.6622 41.9811C83.9904 42.1744 83.3137 42.3677 82.6419 42.5659C81.8396 41.5316 80.9407 40.1638 80.2012 38.4432C80.1722 38.3755 80.1432 38.303 80.1142 38.2354L80.2302 37.7182C80.2495 37.6651 80.467 36.9691 80.003 36.3939C79.8 36.1329 79.539 36.0073 79.3361 35.9445L74.1984 37.8584C73.8649 38.0034 73.5314 38.1097 73.2028 38.1919C71.5257 38.5882 69.9597 38.1725 69.1816 37.1527C68.9931 36.9063 68.6016 36.2924 68.6161 35.234C69.8099 34.7652 71.168 34.3157 72.6808 33.9387C75.2424 33.3055 77.4463 32.9962 79.365 32.9382C80.3848 32.8222 81.4191 33.3297 81.772 34.2577L84.6622 41.9811Z"
					fill="#36B37E"
				/>
				<path
					d="M80.2305 37.7181L80.1145 38.2353L78.3794 46.0215C77.7511 45.7121 77.1228 45.4077 76.4945 45.0983C76.3205 44.1607 76.1803 42.7784 76.4171 41.1448C76.6008 39.8882 76.9536 38.8636 77.2774 38.1096C75.9193 38.1386 74.5564 38.1628 73.1982 38.1918C73.5269 38.1144 73.8604 38.0033 74.1939 37.8583L79.3315 35.9443C79.5345 36.0072 79.7955 36.1328 79.9985 36.3938C80.4673 36.969 80.245 37.6649 80.2305 37.7181Z"
					fill="#57D9A3"
				/>
				<path
					d="M65.8418 29.0668C65.982 31.1257 66.1511 33.5761 66.3976 36.4084C68.3019 36.36 70.8731 35.9347 73.077 34.2141C73.2849 34.0498 73.483 33.8854 73.6667 33.7163C73.8938 33.6728 74.121 33.6245 74.3482 33.581C74.034 33.1363 73.6812 32.5032 73.4637 31.696C73.3622 31.319 73.2269 30.8261 73.2704 30.1881C73.338 29.1441 73.7875 29.0426 73.773 28.2307C73.7682 28.0373 73.8117 27.7473 72.9949 26.2056C72.7967 25.8286 72.5164 25.3114 72.1539 24.7121C71.9268 24.6589 71.6996 24.6106 71.4724 24.5575C71.7528 25.4613 71.7721 25.9977 71.5304 26.1717C71.1631 26.4327 70.2013 25.8576 68.6402 24.4463C68.3309 24.4995 67.2531 24.7266 66.4653 25.6981C65.2908 27.1239 65.7935 28.9073 65.8418 29.0668Z"
					fill="#79F2C0"
				/>
				<path
					d="M68.597 27.0896L66.2384 30.1393C65.4264 32.6912 64.6144 35.248 63.8025 37.7999C63.7058 37.7805 63.585 37.7515 63.4545 37.6935C63.2708 37.6162 63.1307 37.5147 63.034 37.4374C62.976 35.7989 63.1017 34.4311 63.2467 33.4162C63.382 32.4447 63.6768 30.7918 64.3969 28.9262C65.3539 26.4419 66.3109 25.9393 66.7797 25.4656C67.1422 25.0983 67.7028 25.0162 68.1668 25.2482C68.858 25.5865 69.0658 26.4806 68.597 27.0896Z"
					fill="#D4B696"
				/>
				<path
					d="M71.7866 19.3086C72.0428 19.8161 72.2023 20.715 72.2458 21.1645C72.2458 21.2419 72.2409 21.2805 72.3569 21.4013C72.4729 21.527 72.6518 21.6188 72.5793 21.7155C72.5068 21.8073 72.2506 21.875 72.1975 21.962L71.9075 23.4941L71.2405 23.5279L68.9834 23.6343C69.0366 23.5618 70.4333 21.8218 70.4672 21.7058C70.501 21.5898 70.559 21.3434 70.7088 21.3289C70.8587 21.3144 71.4628 20.2221 71.5788 20.0867C71.6948 19.9514 71.6948 19.9031 71.7286 19.6807C71.7673 19.4488 71.7866 19.3086 71.7866 19.3086Z"
					fill="#D4B696"
				/>
				<path
					d="M71.8205 18.9895C71.7818 19.8208 71.4628 20.309 71.1777 20.7343C70.965 21.0533 70.1579 22.2713 70.3705 23.6487C70.4865 24.3834 69.8969 25.0503 69.1574 25.0503C68.7224 25.0503 68.3261 25.0503 67.954 24.9392C67.6591 24.8522 67.1662 24.7072 66.7747 24.335C66.069 23.6584 66.1077 22.6241 66.127 22.0393C66.1319 21.8314 66.185 20.773 66.91 19.7387C67.0792 19.4922 67.2725 19.2795 67.4078 19.149C68.1425 18.4289 70.3899 17.6459 71.8205 18.9895Z"
					fill="#091E42"
				/>
				<path
					d="M68.3067 25.2343C67.8427 25.0024 67.1999 25.1039 66.6586 25.4518C65.112 26.4475 64.5659 27.8974 64.1695 28.7916C63.9375 29.3135 63.7587 29.8162 63.6089 30.3333C64.3339 30.7683 65.6146 31.4015 66.3106 31.7108C66.3106 31.7059 66.3106 31.7011 66.3155 31.6963C66.5378 30.8988 66.8664 30.14 67.2966 29.4344L68.732 27.0806C69.2057 26.4765 68.9979 25.5823 68.3067 25.2343Z"
					fill="#57D9A3"
				/>
				<path
					d="M79.0898 32.5078L79.4282 32.5996C79.5393 32.6286 79.6553 32.6382 79.7713 32.6286L80.2595 32.5754C80.2595 32.5754 80.3126 32.4401 80.3078 32.3918C80.303 32.3676 80.2546 32.2999 80.2546 32.2999C80.2546 32.2999 80.3126 32.1549 80.3078 32.1066C80.303 32.0631 80.2208 31.9568 80.2208 31.9568C80.2208 31.9568 80.3126 31.8118 80.3078 31.7538C80.3078 31.7199 80.2353 31.6281 80.2353 31.6281L80.1338 31.4541L79.868 31.401C79.7955 31.3865 79.7182 31.3865 79.6408 31.4058L79.0995 31.5363L79.0898 32.5078Z"
					fill="#CE9E79"
				/>
				<path
					d="M80.385 32.73C80.0322 32.73 79.7422 32.4448 79.7422 32.0871C79.7422 31.7295 80.0273 31.4443 80.385 31.4443"
					stroke="url(#paint79_linear_1331_7994)"
					strokeWidth="0.5732"
					strokeMiterlimit="10"
				/>
				<path
					d="M80.0273 31.7246L79.7422 32.0871L79.8099 32.2611L79.8872 32.2369L79.8582 32.3529L79.9403 32.4931L80.0273 32.4544L80.0032 32.5704L80.1192 32.6477L80.2497 32.5172L80.0273 31.7246Z"
					fill="#CE9E79"
				/>
				<path
					d="M80.6895 31.0626C80.5107 30.7388 80.3367 30.2748 80.4817 29.8301C80.6363 29.3758 80.9988 29.3275 81.2791 28.849C81.6513 28.1965 81.2308 27.8437 81.4628 27.2009C81.8204 26.2053 83.0771 26.3841 83.7344 25.3498C83.9519 25.0067 84.1839 24.4073 84.0002 23.3634C85.4743 23.2716 86.9484 23.1797 88.4225 23.0879C88.6497 24.1947 88.4854 25.0502 88.3645 25.5045C87.9102 27.1816 86.4603 28.9988 84.7542 29.2018C83.9229 29.2985 82.9707 29.023 82.7242 29.4822C82.6034 29.7093 82.7532 29.922 82.6179 30.2941C82.4778 30.6856 82.1394 30.9224 81.8591 31.0674C81.4725 31.0674 81.081 31.0626 80.6895 31.0626Z"
					fill="url(#paint80_linear_1331_7994)"
				/>
				<path
					d="M142.307 59.4334L146.899 56.6592"
					stroke="#7A869A"
					strokeWidth="1.5514"
					strokeMiterlimit="10"
				/>
				<path
					d="M141.679 60.9413C141.5 60.5063 141.321 60.0762 141.137 59.6412C141.302 59.5059 141.461 59.3754 141.625 59.24C141.635 59.1724 141.659 59.0516 141.737 58.9211C141.795 58.8244 141.872 58.7422 141.969 58.6746L142.867 58.0511C143.075 57.9061 143.336 57.8674 143.578 57.9399L144.951 58.3652L144.786 59.0564L144.487 59.3464C144.322 59.5107 144.1 59.5977 143.863 59.5977H143.273C143.264 60.0085 142.95 60.342 142.544 60.3758C142.259 60.574 141.969 60.7577 141.679 60.9413Z"
					fill="url(#paint81_linear_1331_7994)"
				/>
				<path
					d="M127.455 62.5026C128.204 62.5026 128.948 62.5026 129.697 62.5026C129.576 62.2175 129.427 61.7825 129.378 61.2412C129.33 60.7144 129.393 60.2745 129.456 59.9749C129.001 59.9507 128.542 59.9314 128.088 59.9072C128.073 59.9894 128.044 60.1054 128.006 60.2455C127.948 60.463 127.914 60.5694 127.856 60.6225C127.701 60.7675 127.401 60.6805 127.314 60.6515C127.363 61.275 127.406 61.8888 127.455 62.5026Z"
					fill="url(#paint82_linear_1331_7994)"
				/>
				<path
					d="M124.913 70.3372C123.332 70.7093 122.356 72.2946 122.733 73.8751C123.187 75.7842 125.671 76.5623 126.271 76.0548C126.744 75.6537 125.927 74.5517 126.57 73.6189C127.16 72.7586 128.31 73.0341 128.455 72.5169C128.644 71.8065 126.836 69.8829 124.913 70.3372Z"
					fill="#FFC400"
				/>
				<path
					d="M126.333 73.2851C125.691 72.7776 124.874 72.0188 124.1 70.9555C123.39 69.9792 122.94 69.0464 122.655 68.3214C122.984 66.4558 123.738 65.2185 124.207 64.5709C124.854 63.6767 125.425 63.2708 125.676 63.1064C126.585 62.512 128.006 62.0093 128.358 62.4395C128.716 62.8793 127.943 64.1939 127.281 64.9382C127.01 65.2427 126.831 65.3732 126.589 65.5858C126.019 66.0933 125.294 66.9246 124.666 68.2972C125.27 69.3799 125.874 70.4673 126.478 71.5499C126.435 72.1299 126.386 72.7099 126.333 73.2851Z"
					fill="url(#paint83_linear_1331_7994)"
				/>
				<path
					d="M126.715 70.6173C126.754 70.453 126.802 70.2742 126.875 70.0809C126.957 69.8537 127.054 69.6555 127.145 69.4912C127.257 69.525 127.435 69.5782 127.663 69.6217C127.856 69.6604 128.006 69.6749 128.088 69.6845C128.542 69.7522 129.417 69.8537 131.761 70.0325C131.872 70.1727 132.032 70.3853 132.201 70.6512C132.815 71.6226 133.037 72.5071 133.129 72.8889C134.719 79.4378 135.038 81.9994 135.038 81.9994C135.038 81.9994 136.164 88.2777 136.792 93.7923C136.773 93.8068 136.406 94.353 135.898 94.5511C135.715 94.6236 135.724 94.759 135.381 94.7928C134.704 92.8209 134.095 90.4816 133.757 87.8282C133.641 86.9099 133.564 86.0254 133.525 85.1796C132.974 84.3 132.206 82.9612 131.461 81.2455C130.451 78.9014 130.19 77.4611 129.934 77.4998C129.538 77.5578 129.828 80.8346 129.866 85.6195C129.891 88.4275 129.726 90.7474 129.712 92.2795C129.562 92.3665 129.233 92.6179 128.697 92.4294C128.16 92.2457 127.982 91.9992 127.982 91.9992C127.788 90.7039 127.653 89.2008 127.653 87.5334C127.653 86.1849 127.74 84.9476 127.875 83.8457C127.247 81.9366 126.884 80.2885 126.667 79.0657C126.667 79.0657 125.947 75.0203 126.338 72.3573C126.411 71.9368 126.638 70.9508 126.715 70.6173Z"
					fill="url(#paint84_linear_1331_7994)"
				/>
				<path
					d="M134.564 87.8716C135.072 87.8716 135.541 87.7508 135.952 87.543C136.246 89.4762 136.556 91.6898 136.797 93.7922C136.778 93.8067 136.411 94.3529 135.903 94.551C135.72 94.6235 135.729 94.7589 135.386 94.7927C134.709 92.8208 134.1 90.4815 133.762 87.8281C133.757 87.804 133.757 87.775 133.752 87.7508C134.018 87.8281 134.289 87.8716 134.564 87.8716Z"
					fill="url(#paint85_linear_1331_7994)"
				/>
				<path
					d="M128.939 87.625C129.262 87.625 129.572 87.5766 129.862 87.4848C129.876 88.3113 129.857 89.2151 129.78 90.1865C129.717 90.955 129.63 91.6751 129.523 92.3421C129.465 92.3904 129.369 92.4629 129.233 92.4968C129.18 92.5113 129.016 92.5499 128.707 92.4388C128.17 92.2551 127.991 92.0086 127.991 92.0086C127.798 90.7133 127.663 89.2102 127.663 87.5428C127.663 87.4751 127.663 87.4075 127.663 87.335C128.064 87.5186 128.499 87.625 128.939 87.625Z"
					fill="url(#paint86_linear_1331_7994)"
				/>
				<path
					d="M129.939 77.5046C129.683 77.5433 129.712 78.9304 129.78 81.202C129.606 81.173 129.33 81.1295 129.001 81.0715C128.47 80.9796 128.291 80.941 127.953 80.8926C127.735 80.8588 127.416 80.8153 127.025 80.7718C126.88 80.1435 126.764 79.5732 126.677 79.0754C126.677 79.0754 125.957 75.03 126.348 72.3669C126.411 71.932 126.643 70.946 126.72 70.6173C126.759 70.453 126.807 70.2742 126.88 70.0809C126.962 69.8537 127.058 69.6555 127.15 69.4912C127.261 69.525 127.44 69.5782 127.667 69.6217C127.861 69.6604 128.011 69.6749 128.093 69.6845C128.547 69.7522 129.422 69.8537 131.766 70.0325C131.877 70.1727 132.037 70.3853 132.206 70.6512C132.82 71.6226 133.042 72.5071 133.134 72.8889C134.013 76.5186 134.506 78.9207 134.767 80.3416C134.497 80.5011 134.192 80.6558 133.859 80.8008C133.003 81.173 132.206 81.3614 131.553 81.4533C131.524 81.3856 131.495 81.318 131.461 81.2503C130.456 78.911 130.195 77.4659 129.939 77.5046Z"
					fill="#5E6C84"
				/>
				<path
					d="M140.528 96.2133L139.262 95.8121C137.943 95.3965 136.986 94.2558 136.807 92.8832C136.773 92.6367 136.589 91.6024 136.507 91.1723C136.275 91.124 135.918 91.0805 135.497 91.1481C134.869 91.2496 134.429 91.5396 134.216 91.7039C134.468 92.2646 134.719 92.9364 134.917 93.7145C135.038 94.1978 135.197 94.9663 135.26 95.9233C135.28 96.2133 135.284 96.4549 135.284 96.6144L136.536 96.6048C136.604 96.5274 136.676 96.4501 136.744 96.3728C136.855 96.4453 136.966 96.5178 137.073 96.5951H140.248L140.528 96.2133Z"
					fill="#253858"
				/>
				<path
					d="M127.803 90.8056C127.948 90.7137 128.349 90.4769 128.91 90.4962C129.393 90.5107 129.741 90.7089 129.891 90.8056C129.837 91.0279 129.779 91.342 129.746 91.719C129.683 92.4005 129.654 92.792 129.891 93.0046C129.958 93.0626 130.152 93.2076 130.601 93.1303C130.649 93.1496 130.698 93.169 130.746 93.1883C130.142 93.9229 129.688 94.4836 129.417 94.8557C129.369 94.9234 129.233 95.1119 128.992 95.2037C128.919 95.2327 128.62 95.3487 128.373 95.1699C128.189 95.0394 128.146 94.8316 128.136 94.7736C128.025 93.4493 127.914 92.1298 127.803 90.8056Z"
					fill="#253858"
				/>
				<path
					d="M130.011 58.0605C130.045 58.249 130.118 58.539 130.296 58.8484C130.485 59.1818 130.717 59.3993 130.872 59.5202C130.775 59.6265 130.673 59.7328 130.577 59.8391C130.499 60.2838 130.417 60.7285 130.34 61.1779C130.127 61.2649 129.803 61.3761 129.393 61.4196C128.967 61.4631 128.407 61.5211 128.175 61.2118C128.049 61.0426 128.03 60.8154 128.059 60.54C128.083 60.2886 128.117 60.0856 128.151 59.9841C128.242 59.7087 128.373 59.5347 128.639 59.1963C128.948 58.8 129.127 58.5729 129.446 58.3554C129.663 58.2007 129.871 58.1137 130.011 58.0605Z"
					fill="url(#paint87_linear_1331_7994)"
				/>
				<path
					d="M131.631 65.0304C131.669 65.6394 131.737 66.2967 131.858 66.9975C132.08 68.3218 132.414 69.4769 132.766 70.4484C132.153 70.7432 131.181 71.1202 129.934 71.2458C128.494 71.386 127.329 71.125 126.643 70.9123C126.677 69.6896 126.565 67.969 125.908 66.0502C125.608 65.1754 125.251 64.4166 124.898 63.7883C125.12 63.5756 125.434 63.3098 125.845 63.0391C125.845 63.0391 125.937 62.9763 126.082 62.8893C126.082 62.8893 126.348 62.7298 126.619 62.5945C127.769 62.0193 129.876 61.826 129.876 61.826C132.027 61.7487 134.173 61.6762 136.324 61.5988C137.957 60.8787 139.596 60.1537 141.229 59.4336C141.563 59.8686 141.896 60.3036 142.23 60.7385C140.978 61.681 139.17 62.8361 136.812 63.7399C134.82 64.4939 133.032 64.8564 131.631 65.0304Z"
					fill="url(#paint88_linear_1331_7994)"
				/>
				<path
					d="M125.628 59.2351C124.768 60.7914 124.173 60.7092 124.019 61.6469C123.883 62.483 124.168 63.6671 125.096 64.165C126.145 64.7256 127.295 64.0345 127.358 63.9958C128.001 63.5946 128.267 62.9857 128.364 62.7633C128.89 61.5261 128.122 60.9654 128.668 60.0471C128.886 59.6798 129.108 59.6025 129.915 58.5537C130.031 58.4038 130.205 58.1718 130.224 57.8432C130.253 57.4227 130.017 57.1037 129.939 57.0022C129.466 56.4174 128.629 56.4512 128.378 56.4609C127.629 56.4899 127.097 56.8621 126.933 56.9829C126.208 57.5242 126.276 58.0607 125.628 59.2351Z"
					fill="#ECC19C"
				/>
				<path
					d="M124.125 74.8555C124.359 74.8555 124.55 74.6651 124.55 74.4302C124.55 74.1953 124.359 74.0049 124.125 74.0049C123.89 74.0049 123.699 74.1953 123.699 74.4302C123.699 74.6651 123.89 74.8555 124.125 74.8555Z"
					fill="#57D9A3"
				/>
				<path
					d="M123.699 73.2852C123.934 73.2852 124.125 73.0948 124.125 72.8599C124.125 72.625 123.934 72.4346 123.699 72.4346C123.464 72.4346 123.274 72.625 123.274 72.8599C123.274 73.0948 123.464 73.2852 123.699 73.2852Z"
					fill="#00B8D9"
				/>
				<path
					d="M125.391 75.4747C125.626 75.4747 125.816 75.2842 125.816 75.0493C125.816 74.8144 125.626 74.624 125.391 74.624C125.156 74.624 124.966 74.8144 124.966 75.0493C124.966 75.2842 125.156 75.4747 125.391 75.4747Z"
					fill="#EBECF0"
				/>
				<path
					d="M147.565 55.5859C147.503 55.6053 147.445 55.6294 147.382 55.6584C147.087 55.7889 146.686 55.9726 146.652 56.3157C146.623 56.6202 146.903 56.9441 147.208 57.0166C147.561 57.0987 147.865 56.8329 148.083 56.6299C147.58 56.4172 147.213 56.2577 147.565 55.5859Z"
					fill="#344563"
				/>
				<path
					d="M148.725 55.4945C148.421 55.451 148 55.4365 147.565 55.5863C147.213 56.263 147.575 56.4176 148.087 56.6303C148.097 56.6206 148.107 56.6158 148.112 56.6061C148.513 56.2291 148.662 55.77 148.725 55.4945Z"
					fill="#FFAB00"
				/>
				<path
					d="M130.277 56.838C130.099 57.6306 127.373 58.0366 126.802 57.2053C126.783 57.1763 126.604 56.9057 126.691 56.6398C126.798 56.316 127.233 56.2097 127.368 56.1759C127.846 56.0599 128.257 56.2435 128.417 56.3305C128.914 55.9535 129.485 55.8762 129.867 56.1179C130.099 56.258 130.34 56.5673 130.277 56.838Z"
					fill="#172B4D"
				/>
				<path
					d="M95.3774 119.635C96.8129 121.796 94.1933 127.117 90.6941 127.847C89.5728 128.083 87.7749 127.967 87.1901 126.938C86.8179 126.286 86.9436 125.28 87.3205 124.608C87.7555 123.825 88.3887 123.748 88.5627 122.926C88.6642 122.458 88.5047 122.255 88.7077 121.81C88.901 121.39 89.1426 121.341 89.4955 120.921C90.0175 120.297 89.858 119.944 90.2108 119.422C90.8101 118.543 92.0425 118.412 92.2939 118.383C93.4393 118.262 94.7926 118.755 95.3774 119.635Z"
					fill="#172B4D"
				/>
				<path
					d="M98.7024 147.73L98.3931 151.665L99.2099 151.945L99.611 151.476C99.6883 151.694 99.7657 151.916 99.843 152.133C100.244 152.356 100.814 152.622 101.535 152.796C102.308 152.984 102.975 152.999 103.453 152.974C103.362 152.849 103.217 152.66 103.014 152.443C102.888 152.307 102.675 152.09 102.361 151.839C101.549 151.191 101.245 151.264 101.013 150.858C100.887 150.63 100.882 150.408 100.877 149.968C100.877 149.543 100.926 148.91 101.182 148.146L98.7024 147.73Z"
					fill="#253858"
				/>
				<path
					d="M103.076 145.3L104.338 149.04L105.203 148.978L105.386 148.388C105.546 148.557 105.701 148.731 105.86 148.9C106.319 148.949 106.948 148.968 107.677 148.847C108.46 148.717 109.084 148.465 109.514 148.257C109.383 148.18 109.171 148.064 108.9 147.939C108.731 147.861 108.451 147.75 108.064 147.644C107.064 147.368 106.812 147.552 106.44 147.272C106.232 147.112 106.14 146.909 105.966 146.508C105.797 146.121 105.594 145.517 105.531 144.71L103.076 145.3Z"
					fill="#253858"
				/>
				<path
					d="M93.6518 127.673H91.9844V123.468H95.2903C95.5464 123.709 96.571 124.734 96.4985 126.17C96.4792 126.532 96.4405 127.276 95.8751 127.716C95.3144 128.141 94.4396 128.127 93.6518 127.673Z"
					fill="#172B4D"
				/>
				<path
					d="M104.57 128.442C104.401 128.698 104.183 128.828 103.835 129.036C103.468 129.254 103.289 129.365 103.125 129.302C102.738 129.162 102.535 128.152 102.927 127.586C103.159 127.253 103.449 127.296 103.792 126.794C103.937 126.586 104 126.412 104.14 126.397C104.348 126.378 104.531 126.716 104.584 126.803C104.812 127.224 104.923 127.905 104.57 128.442Z"
					fill="#B5917C"
				/>
				<path
					d="M95.7783 127.427C96.3099 128.113 96.8512 128.833 97.3925 129.597C98.0063 130.457 98.5718 131.303 99.0986 132.125C99.5916 131.632 100.089 131.124 100.592 130.597C101.491 129.655 101.887 129.365 102.695 128.447C103.357 128.969 103.086 128.751 103.748 129.273C103.057 130.283 102.748 130.694 101.902 131.772C101.269 132.579 100.636 133.343 100.017 134.053C99.6786 134.444 99.1131 134.556 98.6492 134.324C98.2625 134.13 97.8614 133.913 97.4505 133.671C96.6676 133.212 95.9812 132.743 95.3916 132.299L95.7783 127.427Z"
					fill="url(#paint89_linear_1331_7994)"
				/>
				<path
					d="M96.5225 139.205C95.9183 139.176 95.2368 139.113 94.4974 138.983C93.7192 138.848 93.0233 138.664 92.4191 138.476C92.2644 134.851 92.1146 131.226 91.96 127.601C92.0663 127.47 92.8348 126.547 94.1542 126.513C95.4157 126.484 96.2131 127.292 96.334 127.422C96.4016 131.351 96.4596 135.281 96.5225 139.205Z"
					fill="#253858"
				/>
				<path
					d="M95.6139 130.051C95.3819 129.2 94.8358 128.843 94.3621 127.567C94.1737 127.064 94.077 126.634 94.0238 126.349L90.6213 126.165C90.515 126.349 90.3313 126.595 90.0365 126.774C89.4662 127.117 88.978 126.948 88.2482 127.112C87.8954 127.19 87.4169 127.368 86.8853 127.799C87.0834 131.177 87.2816 134.56 87.4749 137.939H95.8266C94.947 135.271 95.0823 133.473 95.3916 132.293C95.5656 131.641 95.8556 130.94 95.6139 130.051Z"
					fill="#FF991F"
				/>
				<path
					d="M93.7239 126.513C93.4532 126.61 92.9651 126.75 92.3368 126.75C91.5586 126.75 90.9787 126.532 90.708 126.411C90.8433 126.194 90.9883 125.909 91.085 125.561C91.2107 125.116 91.2155 124.725 91.1865 124.444C92.0613 124.56 92.9409 124.681 93.8157 124.797C93.7867 125.367 93.7529 125.943 93.7239 126.513Z"
					fill="#9C7761"
				/>
				<path
					d="M94.6907 135.29C94.768 135.498 94.0962 136.024 95.4012 135.459C95.4833 135.425 95.8361 135.353 96.0295 135.019C96.2325 134.671 95.9666 134.4 96.1986 134.101C96.3243 133.941 96.4693 133.932 96.5466 133.729C96.5998 133.584 96.6046 133.395 96.537 133.361C96.4596 133.323 96.3485 133.516 96.0198 133.787C95.696 134.053 95.6428 133.999 95.4012 134.236C95.2997 134.338 95.2513 134.405 95.0338 134.618C94.9227 134.729 94.9082 134.739 94.8743 134.782C94.8019 134.889 94.6279 135.116 94.6907 135.29Z"
					fill="#B5917C"
				/>
				<path
					d="M95.0434 120.752C95.1207 121.027 95.1932 121.332 95.2464 121.665C95.3237 122.12 95.3575 122.54 95.3672 122.912C95.3962 122.98 95.4445 123.096 95.5219 123.236C95.749 123.662 96.0003 123.923 95.9182 124.014C95.9134 124.024 95.5895 124.116 95.5364 124.155C95.4155 124.232 95.401 125.179 95.1546 125.542C94.6567 126.281 92.0952 126.242 91.375 125.01C91.1769 124.667 91.1624 124.304 91.1865 124.043C91.2155 124.039 91.2687 124.024 91.3267 124.005C91.7375 123.855 91.9115 123.531 91.9115 123.531C91.9888 123.106 92.1532 122.816 92.2643 122.656C92.767 121.931 93.6611 121.641 93.9559 121.612C94.0043 121.607 94.2121 121.588 94.4731 121.501C94.5214 121.487 94.5697 121.467 94.6229 121.438C94.7727 121.366 94.9467 121.192 95.0434 120.752Z"
					fill="#B5917C"
				/>
				<path
					d="M94.043 136.397L97.6147 132.623L100.181 133.193L102.999 132.386L99.5673 135.899L94.043 136.397Z"
					fill="#172B4D"
				/>
				<path
					d="M97.7793 134.169C97.557 133.986 96.6773 134.29 96.6773 134.29L96.7111 134.783L96.4937 135.769C96.4937 135.769 97.4845 135.465 97.7019 135.223C97.7599 135.16 97.7889 134.967 97.7889 134.967C97.7889 134.967 97.9388 134.856 97.9774 134.817C98.0741 134.72 98.1466 134.445 98.0548 134.343C98.0209 134.305 97.8469 134.343 97.8469 134.343C97.8469 134.343 97.8131 134.198 97.7793 134.169Z"
					fill="#B5917C"
				/>
				<path
					d="M95.5605 134.715C95.8698 134.667 96.1066 134.575 96.2661 134.503C96.4498 134.42 96.59 134.329 96.7108 134.29C96.7833 134.266 96.851 134.261 96.9138 134.295C96.9911 134.333 97.0443 134.415 97.0588 134.493C97.0878 134.638 96.9573 134.686 96.9186 134.913C96.8848 135.097 96.9525 135.145 96.8896 135.242C96.822 135.343 96.7301 135.314 96.6528 135.421C96.5803 135.527 96.6431 135.595 96.5851 135.687C96.4885 135.851 96.1598 135.841 96.039 135.841C95.7587 135.841 95.3527 135.899 94.821 136.18C94.8017 136.054 94.792 135.885 94.8355 135.687C94.9515 135.169 95.3623 134.894 95.4735 134.826C95.5025 134.788 95.5315 134.754 95.5605 134.715Z"
					fill="#B5917C"
				/>
				<path
					d="M88.1657 140.138C89.1807 141.433 90.9061 141.945 92.4624 141.414L101.172 138.441C101.264 139.156 101.394 139.935 101.573 140.761C101.766 141.66 101.974 142.39 102.259 143.366C102.453 144.043 102.752 145.082 103.042 146.097C103.704 145.957 104.381 145.797 105.072 145.614C105.381 145.531 105.686 145.449 105.986 145.367C105.517 143.023 105.12 141.056 104.719 139.04C104.545 138.146 104.366 137.233 103.656 136.329C102.776 135.217 101.578 134.739 100.819 134.521L87.4746 137.939V138.122C87.4746 138.857 87.7163 139.562 88.1657 140.138Z"
					fill="url(#paint90_linear_1331_7994)"
				/>
				<path
					d="M90.5004 127.504H88.833V123.299C89.9785 123.086 91.1239 122.874 92.2694 122.661C92.1775 122.879 92.0664 123.246 92.1147 123.676C92.2355 124.744 93.236 125 93.352 126.001C93.4148 126.547 93.1973 127.185 92.7285 127.547C92.163 127.973 91.2882 127.958 90.5004 127.504Z"
					fill="#172B4D"
				/>
				<path
					d="M90.9839 139.205C90.3797 139.176 89.6983 139.113 88.9588 138.983C88.1807 138.848 87.4847 138.664 86.8805 138.476C86.7259 134.851 86.576 131.226 86.4214 127.601C86.5277 127.47 87.2962 126.547 88.6156 126.513C89.8771 126.484 90.6746 127.292 90.7954 127.422C90.8631 131.351 90.9211 135.281 90.9839 139.205Z"
					fill="#253858"
				/>
				<path
					d="M92.4624 141.418C93.516 141.472 94.6518 141.486 95.8649 141.433C96.6286 141.399 97.3632 141.346 98.0592 141.278C98.2477 141.278 98.4314 141.278 98.6199 141.278C98.528 141.849 98.4362 142.52 98.3734 143.274C98.3202 143.878 98.3009 144.4 98.2912 144.797C98.2815 145.145 98.2815 145.401 98.2815 145.502C98.2815 146.049 98.2622 146.943 98.18 148.46C98.47 148.629 98.9678 148.881 99.6396 148.973C100.423 149.079 101.051 148.924 101.384 148.818C101.708 146.339 102.032 143.859 102.356 141.38L102.39 139.485C102.375 139.369 102.235 138.422 101.288 137.929C100.722 137.634 100.166 137.653 99.9393 137.673C97.4454 138.915 94.9515 140.167 92.4624 141.418Z"
					fill="url(#paint91_linear_1331_7994)"
				/>
				<path
					opacity="0.49"
					d="M99.0454 138.112C97.2668 139.006 95.4882 139.896 93.7096 140.79C93.4438 141.027 93.1779 141.239 92.9121 141.433C93.7627 141.467 94.6665 141.471 95.6187 141.438C96.8753 140.669 98.1077 139.596 99.0454 138.112Z"
					fill="url(#paint92_linear_1331_7994)"
				/>
				<path
					d="M88.5961 127.702C89.3646 128.302 89.0408 130.08 88.7169 132.99C88.5961 134.073 88.5139 134.952 88.4656 135.513C90.5874 135.174 92.627 135.189 94.7487 134.846C94.8212 135.092 95.0629 135.677 95.029 136.011C92.5641 136.615 90.336 137.432 87.9871 137.852C87.1607 138.002 86.3777 137.427 86.2569 136.595C86.0974 135.474 86.02 134.498 85.9814 133.7C85.962 128.679 86.629 128.007 86.8852 127.799C86.9915 127.712 87.3975 127.383 87.9098 127.422C87.9098 127.427 88.2771 127.456 88.5961 127.702Z"
					fill="url(#paint93_linear_1331_7994)"
				/>
				<path
					d="M129.939 202.654L128.837 202.432L142.089 137.832L143.191 138.059L129.939 202.654Z"
					fill="url(#paint94_linear_1331_7994)"
				/>
			</g>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_1331_7994"
				x1="104.039"
				y1="236.443"
				x2="104.039"
				y2="172.5"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_1331_7994"
				x1="198.762"
				y1="155.133"
				x2="198.762"
				y2="129.301"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0242" stopColor="#091E42" stopOpacity="0" />
				<stop offset="0.5932" stopColor="#091E42" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_1331_7994"
				x1="205.773"
				y1="180.543"
				x2="225.461"
				y2="160.855"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0228" stopColor="#091E42" stopOpacity="0.4" />
				<stop offset="0.9989" stopColor="#091E42" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_1331_7994"
				x1="30.9848"
				y1="155.414"
				x2="11.2965"
				y2="135.726"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0228" stopColor="#091E42" stopOpacity="0.4" />
				<stop offset="0.9989" stopColor="#091E42" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_1331_7994"
				x1="68.9947"
				y1="203.928"
				x2="68.9947"
				y2="171.624"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0242" stopColor="#091E42" stopOpacity="0" />
				<stop offset="0.5932" stopColor="#091E42" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_1331_7994"
				x1="45.5188"
				y1="78.5871"
				x2="45.5188"
				y2="45.2916"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.0242" stopColor="#091E42" stopOpacity="0" />
				<stop offset="0.5932" stopColor="#091E42" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_1331_7994"
				x1="108.094"
				y1="236.487"
				x2="108.094"
				y2="178.922"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<radialGradient
				id="paint7_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(124.431 90.5768) rotate(6.34399) scale(35.2995 28.2389)"
			>
				<stop offset="0.0873" stopColor="#79F2C0" stopOpacity="0.4" />
				<stop offset="1" stopColor="#79F2C0" stopOpacity="0.8" />
			</radialGradient>
			<linearGradient
				id="paint8_linear_1331_7994"
				x1="76.465"
				y1="76.4303"
				x2="144.208"
				y2="98.3136"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint9_linear_1331_7994"
				x1="71.1423"
				y1="91.8379"
				x2="139.531"
				y2="112.796"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint10_linear_1331_7994"
				x1="73.8425"
				y1="84.5478"
				x2="141.585"
				y2="106.431"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint11_linear_1331_7994"
				x1="73.3061"
				y1="84.7769"
				x2="141.695"
				y2="105.735"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint12_linear_1331_7994"
				x1="76.1013"
				y1="77.5552"
				x2="143.844"
				y2="99.4385"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint13_linear_1331_7994"
				x1="70.5385"
				y1="93.8082"
				x2="138.928"
				y2="114.766"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint14_linear_1331_7994"
				x1="73.4529"
				y1="85.7543"
				x2="141.196"
				y2="107.638"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint15_linear_1331_7994"
				x1="72.7821"
				y1="86.4873"
				x2="141.171"
				y2="107.445"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<radialGradient
				id="paint16_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(78.3372 170.621) rotate(-14.2822) scale(30.9236 24.7398)"
			>
				<stop offset="0.0873" stopColor="#79F2C0" stopOpacity="0.4" />
				<stop offset="1" stopColor="#79F2C0" stopOpacity="0.8" />
			</radialGradient>
			<linearGradient
				id="paint17_linear_1331_7994"
				x1="34.6456"
				y1="173.883"
				x2="96.9414"
				y2="170.92"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint18_linear_1331_7994"
				x1="35.1586"
				y1="189.906"
				x2="97.6963"
				y2="185.984"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint19_linear_1331_7994"
				x1="35.0454"
				y1="188.105"
				x2="97.5832"
				y2="184.182"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint20_linear_1331_7994"
				x1="35.0087"
				y1="181.52"
				x2="97.3046"
				y2="178.557"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint21_linear_1331_7994"
				x1="34.6609"
				y1="181.97"
				x2="97.1985"
				y2="178.047"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#57D9A3" />
				<stop offset="0.6856" stopColor="#57D9A3" stopOpacity="0" />
				<stop offset="1" stopColor="#57D9A3" />
			</linearGradient>
			<linearGradient
				id="paint22_linear_1331_7994"
				x1="167.908"
				y1="108.68"
				x2="206.63"
				y2="88.8727"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFAB00" />
				<stop offset="1" stopColor="#FFE380" />
			</linearGradient>
			<linearGradient
				id="paint23_linear_1331_7994"
				x1="81.5274"
				y1="230.691"
				x2="81.5274"
				y2="187.681"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint24_linear_1331_7994"
				x1="83.4203"
				y1="124.357"
				x2="83.4203"
				y2="75.4714"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint25_linear_1331_7994"
				x1="153.857"
				y1="234.124"
				x2="153.857"
				y2="200.486"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="0.7744" stopColor="#F2F3F6" stopOpacity="0.4064" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint26_linear_1331_7994"
				x1="150.486"
				y1="233.98"
				x2="150.486"
				y2="185.048"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint27_linear_1331_7994"
				x1="144.027"
				y1="234.131"
				x2="144.027"
				y2="182.524"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint28_linear_1331_7994"
				x1="86.7072"
				y1="230.436"
				x2="86.7072"
				y2="186.02"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint29_linear_1331_7994"
				x1="125.22"
				y1="236.418"
				x2="125.22"
				y2="177.223"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint30_linear_1331_7994"
				x1="132.165"
				y1="236.593"
				x2="132.165"
				y2="182.447"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint31_linear_1331_7994"
				x1="92.3073"
				y1="269.974"
				x2="138.345"
				y2="223.936"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0065FF" />
				<stop offset="0.1102" stopColor="#1171FF" />
				<stop offset="0.3181" stopColor="#2B83FF" />
				<stop offset="0.5325" stopColor="#3D90FF" />
				<stop offset="0.7554" stopColor="#4897FF" />
				<stop offset="1" stopColor="#4C9AFF" />
			</linearGradient>
			<linearGradient
				id="paint32_linear_1331_7994"
				x1="167.265"
				y1="144.108"
				x2="179.417"
				y2="123.059"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FAFBFC" stopOpacity="0" />
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<radialGradient
				id="paint33_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(176.852 186.99) rotate(18.0236) scale(15.1235 15.1235)"
			>
				<stop stopColor="#B2D4FF" stopOpacity="0.6" />
				<stop offset="1" stopColor="#B2D4FF" />
			</radialGradient>
			<linearGradient
				id="paint34_linear_1331_7994"
				x1="42.0147"
				y1="124.384"
				x2="119.785"
				y2="124.384"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1315" stopColor="#2684FF" />
				<stop offset="0.3901" stopColor="#1E7DFF" stopOpacity="0.9007" />
				<stop offset="0.7916" stopColor="#086CFF" stopOpacity="0.7465" />
				<stop offset="0.9127" stopColor="#0065FF" stopOpacity="0.7" />
			</linearGradient>
			<linearGradient
				id="paint35_linear_1331_7994"
				x1="114.279"
				y1="87.721"
				x2="45.5177"
				y2="119.923"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint36_linear_1331_7994"
				x1="34.3342"
				y1="137.804"
				x2="127.32"
				y2="123.273"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint37_linear_1331_7994"
				x1="35.3545"
				y1="144.332"
				x2="128.341"
				y2="129.801"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint38_linear_1331_7994"
				x1="36.4144"
				y1="148.491"
				x2="128.947"
				y2="129.001"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#0065FF" stopOpacity="0" />
				<stop offset="0.5761" stopColor="#0065FF" stopOpacity="0.5761" />
				<stop offset="1" stopColor="#0065FF" />
			</linearGradient>
			<linearGradient
				id="paint39_linear_1331_7994"
				x1="35.8527"
				y1="147.521"
				x2="128.839"
				y2="132.989"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint40_linear_1331_7994"
				x1="36.5325"
				y1="149.052"
				x2="129.065"
				y2="129.562"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#0065FF" stopOpacity="0" />
				<stop offset="0.5761" stopColor="#0065FF" stopOpacity="0.5761" />
				<stop offset="1" stopColor="#0065FF" />
			</linearGradient>
			<linearGradient
				id="paint41_linear_1331_7994"
				x1="111.14"
				y1="81.0167"
				x2="42.3784"
				y2="113.218"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint42_linear_1331_7994"
				x1="35.6671"
				y1="146.335"
				x2="128.653"
				y2="131.804"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint43_linear_1331_7994"
				x1="36.8145"
				y1="153.675"
				x2="129.801"
				y2="139.144"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint44_linear_1331_7994"
				x1="38.1148"
				y1="156.564"
				x2="130.648"
				y2="137.074"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#0065FF" stopOpacity="0" />
				<stop offset="0.5761" stopColor="#0065FF" stopOpacity="0.5761" />
				<stop offset="1" stopColor="#0065FF" />
			</linearGradient>
			<radialGradient
				id="paint45_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(119.043 163.523) rotate(4.54811) scale(33.2698 26.615)"
			>
				<stop offset="0.0873" stopColor="#00C7E5" stopOpacity="0.8" />
				<stop offset="0.2511" stopColor="#10CAE7" stopOpacity="0.8" />
				<stop offset="0.5699" stopColor="#39D4EB" stopOpacity="0.8" />
				<stop offset="1" stopColor="#79E2F2" stopOpacity="0.8" />
			</radialGradient>
			<linearGradient
				id="paint46_linear_1331_7994"
				x1="37.9431"
				y1="137.777"
				x2="107"
				y2="143.703"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.5004" stopColor="#00C7E5" />
				<stop offset="1" stopColor="#00C7E5" stopOpacity="0.1" />
			</linearGradient>
			<linearGradient
				id="paint47_linear_1331_7994"
				x1="113.809"
				y1="139.836"
				x2="184.689"
				y2="171.847"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1315" stopColor="#2684FF" />
				<stop offset="0.3901" stopColor="#1E7DFF" stopOpacity="0.9007" />
				<stop offset="0.7916" stopColor="#086CFF" stopOpacity="0.7465" />
				<stop offset="0.9127" stopColor="#0065FF" stopOpacity="0.7" />
			</linearGradient>
			<linearGradient
				id="paint48_linear_1331_7994"
				x1="194.727"
				y1="136.239"
				x2="118.805"
				y2="137.279"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint49_linear_1331_7994"
				x1="194.747"
				y1="137.662"
				x2="118.825"
				y2="138.702"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint50_linear_1331_7994"
				x1="101.095"
				y1="149.561"
				x2="191.823"
				y2="174.586"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0065FF" />
				<stop offset="0.8609" stopColor="#0065FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint51_linear_1331_7994"
				x1="98.0634"
				y1="160.552"
				x2="188.791"
				y2="185.578"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0065FF" />
				<stop offset="0.8609" stopColor="#0065FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint52_linear_1331_7994"
				x1="98.1001"
				y1="162.348"
				x2="190.453"
				y2="182.679"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0065FF" />
				<stop offset="0.8609" stopColor="#0065FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint53_linear_1331_7994"
				x1="194.659"
				y1="131.29"
				x2="118.738"
				y2="132.33"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint54_linear_1331_7994"
				x1="92.7266"
				y1="41.352"
				x2="154.61"
				y2="54.1357"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1315" stopColor="#0065FF" />
				<stop offset="0.9127" stopColor="#0065FF" />
			</linearGradient>
			<linearGradient
				id="paint55_linear_1331_7994"
				x1="155.833"
				y1="22.2844"
				x2="95.8211"
				y2="36.604"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#2684FF" stopOpacity="0" />
				<stop offset="1" stopColor="#2684FF" />
			</linearGradient>
			<linearGradient
				id="paint56_linear_1331_7994"
				x1="84.392"
				y1="51.3362"
				x2="160.773"
				y2="55.0528"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint57_linear_1331_7994"
				x1="83.939"
				y1="60.6435"
				x2="160.32"
				y2="64.3601"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint58_linear_1331_7994"
				x1="84.3234"
				y1="62.1236"
				x2="161.163"
				y2="61.8256"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#0065FF" stopOpacity="0" />
				<stop offset="1" stopColor="#0065FF" />
			</linearGradient>
			<linearGradient
				id="paint59_linear_1331_7994"
				x1="84.5781"
				y1="47.5065"
				x2="160.959"
				y2="51.2231"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint60_linear_1331_7994"
				x1="84.1799"
				y1="55.6941"
				x2="160.561"
				y2="59.4107"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2684FF" />
				<stop offset="0.8609" stopColor="#2684FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint61_linear_1331_7994"
				x1="84.3021"
				y1="56.5928"
				x2="161.141"
				y2="56.2949"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.1391" stopColor="#0065FF" stopOpacity="0" />
				<stop offset="1" stopColor="#0065FF" />
			</linearGradient>
			<linearGradient
				id="paint62_linear_1331_7994"
				x1="132.419"
				y1="61.9916"
				x2="185.281"
				y2="67.9929"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#C1C7D0" />
				<stop offset="1" stopColor="#F4F5F7" />
			</linearGradient>
			<linearGradient
				id="paint63_linear_1331_7994"
				x1="147.858"
				y1="70.5411"
				x2="171.557"
				y2="73.2315"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00B8D9" />
				<stop offset="1" stopColor="#79E2F2" />
			</linearGradient>
			<linearGradient
				id="paint64_linear_1331_7994"
				x1="119.001"
				y1="128.428"
				x2="119.001"
				y2="73.2022"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FAFBFC" stopOpacity="0" />
				<stop offset="0.4449" stopColor="white" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<radialGradient
				id="paint65_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(142.692 113.686) scale(25.4439)"
			>
				<stop offset="0.0873" stopColor="#00C7E5" stopOpacity="0.8" />
				<stop offset="0.2053" stopColor="#10CBE7" stopOpacity="0.8" />
				<stop offset="0.4351" stopColor="#39D6ED" stopOpacity="0.8" />
				<stop offset="0.7505" stopColor="#7AE6F7" stopOpacity="0.8" />
				<stop offset="1" stopColor="#B3F5FF" stopOpacity="0.8" />
			</radialGradient>
			<linearGradient
				id="paint66_linear_1331_7994"
				x1="104.404"
				y1="105.753"
				x2="168.86"
				y2="124.372"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint67_linear_1331_7994"
				x1="99.9647"
				y1="122.429"
				x2="165.006"
				y2="140.152"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint68_linear_1331_7994"
				x1="102.119"
				y1="113.663"
				x2="166.576"
				y2="132.281"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint69_linear_1331_7994"
				x1="102.216"
				y1="114.165"
				x2="167.258"
				y2="131.888"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint70_linear_1331_7994"
				x1="123.612"
				y1="94.469"
				x2="144.596"
				y2="94.469"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.5004" stopColor="#008DA6" />
				<stop offset="1" stopColor="#008DA6" stopOpacity="0.1" />
			</linearGradient>
			<linearGradient
				id="paint71_linear_1331_7994"
				x1="61.0754"
				y1="158.149"
				x2="61.0754"
				y2="109.493"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FAFBFC" stopOpacity="0" />
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint72_linear_1331_7994"
				x1="34.871"
				y1="98.428"
				x2="65.7682"
				y2="66.7041"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFAB00" />
				<stop offset="1" stopColor="#FFE380" />
			</linearGradient>
			<radialGradient
				id="paint73_radial_1331_7994"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(82.673 57.2788) rotate(-5.90044) scale(29.4953 23.5976)"
			>
				<stop offset="0.0873" stopColor="#00C7E5" stopOpacity="0.4" />
				<stop offset="1" stopColor="#00C7E5" stopOpacity="0.8" />
			</radialGradient>
			<linearGradient
				id="paint74_linear_1331_7994"
				x1="40.1605"
				y1="54.3856"
				x2="99.3537"
				y2="60.2567"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint75_linear_1331_7994"
				x1="39.237"
				y1="69.6718"
				x2="98.7972"
				y2="74.6685"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint76_linear_1331_7994"
				x1="39.4396"
				y1="61.6521"
				x2="98.6328"
				y2="67.5232"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint77_linear_1331_7994"
				x1="39.8723"
				y1="62.0992"
				x2="99.4325"
				y2="67.096"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00C7E5" />
				<stop offset="0.6856" stopColor="#00C7E5" stopOpacity="0" />
				<stop offset="1" stopColor="#00C7E5" />
			</linearGradient>
			<linearGradient
				id="paint78_linear_1331_7994"
				x1="80.3834"
				y1="32.0909"
				x2="82.1577"
				y2="32.0909"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F4F5F7" />
				<stop offset="1" stopColor="#C1C7D0" />
			</linearGradient>
			<linearGradient
				id="paint79_linear_1331_7994"
				x1="79.6031"
				y1="32.086"
				x2="80.3836"
				y2="32.086"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F4F5F7" />
				<stop offset="1" stopColor="#C1C7D0" />
			</linearGradient>
			<linearGradient
				id="paint80_linear_1331_7994"
				x1="84.4836"
				y1="31.0648"
				x2="84.4835"
				y2="23.0833"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F4F5F7" stopOpacity="0.4" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint81_linear_1331_7994"
				x1="141.141"
				y1="59.4263"
				x2="144.952"
				y2="59.4263"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.3771" stopColor="#F1DBCB" />
				<stop offset="1" stopColor="#EFC7B0" />
			</linearGradient>
			<linearGradient
				id="paint82_linear_1331_7994"
				x1="129.695"
				y1="61.2074"
				x2="127.315"
				y2="61.2074"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.3771" stopColor="#F1DBCB" />
				<stop offset="1" stopColor="#EFC7B0" />
			</linearGradient>
			<linearGradient
				id="paint83_linear_1331_7994"
				x1="128.455"
				y1="67.7819"
				x2="122.661"
				y2="67.7819"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#253858" />
				<stop offset="1" stopColor="#344563" />
			</linearGradient>
			<linearGradient
				id="paint84_linear_1331_7994"
				x1="136.798"
				y1="82.1444"
				x2="126.228"
				y2="82.1444"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.3771" stopColor="#F1DBCB" />
				<stop offset="1" stopColor="#EFC7B0" />
			</linearGradient>
			<linearGradient
				id="paint85_linear_1331_7994"
				x1="136.798"
				y1="91.1722"
				x2="133.754"
				y2="91.1722"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#253858" />
				<stop offset="1" stopColor="#344563" />
			</linearGradient>
			<linearGradient
				id="paint86_linear_1331_7994"
				x1="129.867"
				y1="89.9247"
				x2="127.661"
				y2="89.9247"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#253858" />
				<stop offset="1" stopColor="#344563" />
			</linearGradient>
			<linearGradient
				id="paint87_linear_1331_7994"
				x1="130.869"
				y1="59.759"
				x2="128.042"
				y2="59.759"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.3771" stopColor="#F1DBCB" />
				<stop offset="1" stopColor="#EFC7B0" />
			</linearGradient>
			<linearGradient
				id="paint88_linear_1331_7994"
				x1="142.221"
				y1="65.3555"
				x2="124.892"
				y2="65.3555"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#253858" />
				<stop offset="1" stopColor="#344563" />
			</linearGradient>
			<linearGradient
				id="paint89_linear_1331_7994"
				x1="95.3898"
				y1="130.936"
				x2="103.745"
				y2="130.936"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF991F" />
				<stop offset="1" stopColor="#FFC400" />
			</linearGradient>
			<linearGradient
				id="paint90_linear_1331_7994"
				x1="93.187"
				y1="145.2"
				x2="102.876"
				y2="135.511"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF991F" />
				<stop offset="1" stopColor="#FFC400" />
			</linearGradient>
			<linearGradient
				id="paint91_linear_1331_7994"
				x1="92.4626"
				y1="143.329"
				x2="102.385"
				y2="143.329"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF991F" />
				<stop offset="1" stopColor="#FFC400" />
			</linearGradient>
			<linearGradient
				id="paint92_linear_1331_7994"
				x1="90.1812"
				y1="139.73"
				x2="100.611"
				y2="139.731"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC400" />
				<stop offset="1" stopColor="#FFF0B2" />
			</linearGradient>
			<linearGradient
				id="paint93_linear_1331_7994"
				x1="85.9794"
				y1="132.65"
				x2="95.0319"
				y2="132.65"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF991F" />
				<stop offset="1" stopColor="#FFC400" />
			</linearGradient>
			<linearGradient
				id="paint94_linear_1331_7994"
				x1="116.693"
				y1="181.399"
				x2="155.335"
				y2="159.089"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FAFBFC" stopOpacity="0" />
				<stop offset="0.4449" stopColor="#EBECF0" />
				<stop offset="1" stopColor="#FAFBFC" stopOpacity="0" />
			</linearGradient>
			<clipPath id="clip0_1331_7994">
				<rect width="237" height="271" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export default CreateTeamOnBoardingSVG;
